function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "python");

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "raspberrypi");

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "dot-net");

var _ref4 =
/*#__PURE__*/
React.createElement("title", null, "adobephotoshop");

var _ref5 =
/*#__PURE__*/
React.createElement("title", null, "html5");

var _ref6 =
/*#__PURE__*/
React.createElement("title", null, "react");

var _ref7 =
/*#__PURE__*/
React.createElement("title", null, "javascript");

var _ref8 =
/*#__PURE__*/
React.createElement("title", null, "css3");

var _ref9 =
/*#__PURE__*/
React.createElement("title", null, "chrome");

var _ref10 =
/*#__PURE__*/
React.createElement("symbol", {
  id: "icon-html-five",
  viewBox: "0 0 32 32"
}, React.createElement("title", null, "html-five"), React.createElement("path", {
  d: "M1.892 0l2.567 28.801 11.524 3.199 11.554-3.204 2.572-28.796h-28.216zM24.52 9.42h-13.517l0.322 3.617h12.874l-0.97 10.844-7.245 2.008-7.237-2.008-0.495-5.547h3.547l0.252 2.82 3.933 1.060 0.009-0.002 3.935-1.062 0.408-4.58h-12.242l-0.953-10.681h17.694l-0.316 3.532z"
}));

var _ref11 =
/*#__PURE__*/
React.createElement("symbol", {
  id: "icon-MVC",
  x: "0px",
  y: "0px",
  viewBox: "-133.2 139.1 124 125.9"
}, React.createElement("g", {
  id: "XMLID_188_"
}, React.createElement("path", {
  id: "XMLID_201_",
  fill: "#3B144D",
  d: "M-133.2,245.6c0,9.4,7.6,17,17,17h90c9.4,0,17-7.6,17-17v-89c0-9.4-7.6-17-19.6-17h-90 c-6.8,0-14.4,7.6-14.4,17C-133.2,156.6-133.2,245.6-133.2,245.6z"
}), React.createElement("path", {
  id: "XMLID_200_",
  fill: "none",
  stroke: "#FFFFFF",
  strokeMiterlimit: 10,
  d: "M-133.2,245.6c0,9.4,7.6,17,17,17h90 c9.4,0,17-7.6,17-17v-89c0-9.4-7.6-17-19.6-17h-90c-6.8,0-14.4,7.6-14.4,17C-133.2,156.6-133.2,245.6-133.2,245.6z"
})), React.createElement("polygon", {
  id: "XMLID_189_",
  fill: "none",
  points: "-132.5,180.9 -8.5,180.9 -5.9,261.3 -129.9,261.3 "
}), React.createElement("path", {
  fill: "none",
  stroke: "#FFFFFF",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  d: "M-119.3,263.1H-23c6.6,0,12-5.4,12-12v-97.8 c0-6.6-5.4-12-14.6-12h-96.3c-4,0-9.4,5.4-9.4,12v97.8C-131.3,257.7-125.9,263.1-119.3,263.1z"
}), React.createElement("g", null, React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M-124.4,219.1c0-2.1,1.4-3.7,3.5-3.7 c2,0,3.4,1.5,3.4,3.7c0,2.1-1.3,3.7-3.5,3.7C-123,222.7-124.4,221.2-124.4,219.1z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M-111,222.1V183h5.5l12.5,19.8 c2.9,4.6,5.2,8.7,7,12.7l0.1-0.1c-0.5-5.2-0.6-10-0.6-16.1V183h4.8v39.1h-5.1l-12.4-19.8c-2.7-4.3-5.3-8.8-7.3-13l-0.2,0.1 c0.3,4.9,0.4,9.6,0.4,16.1v16.7H-111z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M-55.1,203.8h-15.2v14.1h16.9v4.2h-22V183h21.1 v4.2h-16.1v12.4h15.2V203.8z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M-35.9,187.3h-11.9V183h28.9v4.3h-11.9v34.8 h-5.1V187.3z"
})));

var _ref12 =
/*#__PURE__*/
React.createElement("symbol", {
  id: "icon-c-sharp",
  viewBox: "0 0 340 363"
}, React.createElement("title", null, "c-sharp"), React.createElement("g", null, React.createElement("path", {
  fill: "#F1F1F1",
  d: "M10,180.8c0-21.7,0-43.3,0-65c0-11.2,2.3-21.6,9.7-30.6c4.5-5.4,10.4-8.8,16.2-12.1 c30.6-17.8,61.2-35.5,92-52.9c9.6-5.4,18.7-12.2,29.9-14.6c13.8-3,26.5-0.7,38.7,6.4c18.5,10.8,37.1,21.4,55.7,32.1 c19.3,11.1,38.6,22.1,57.7,33.5c11,6.6,16.3,17,18.2,29.5c0.9,5.8,0.9,11.6,0.9,17.4c0,40.3,0.2,80.7-0.1,121 c-0.1,13.4-3.1,26.1-14.2,35.4c-5.3,4.4-11.4,7.5-17.2,10.9c-23.4,13.6-46.8,27.2-70.4,40.5c-13,7.3-25.3,16.1-39.2,21.6 c-15.1,6-30.4,4.8-44.7-3.3C119.4,337,95.7,323.3,72,309.5c-15.7-9.3-32.2-17.4-47.1-27.9c-8.3-5.9-12.1-14.5-14-24.3 c-1.1-5.9-0.9-11.9-0.9-17.9C10,219.8,10,200.3,10,180.8z"
}), React.createElement("path", {
  fill: "#D9D9D9",
  d: "M325,259c-1.2,10.5-6.7,18.5-15.6,23.7c-24.8,14.5-49.8,28.6-74.7,43c-13.7,7.9-27.1,16.2-40.9,23.7 c-16.9,9.2-34,8.6-50.7-0.9c-21.3-12.2-42.6-24.6-63.9-36.8c-16.4-9.4-33-18.6-49.2-28.3c-12-7.2-17.9-18.6-18-32.5 c-0.2-46.5-0.1-93,0-139.4c0-4.6,0.5-9.2,3-13.4c0.2,0.2,0.4,0.3,0.6,0.5c0.8,1.1,1.2,2.3,1.5,3.6c0,2,0.8,4.2-2,5.1 c0-0.1-0.1-0.3-0.2-0.5c-1.2,0.8-0.4,2-0.4,3c-0.1,48.5,0.1,97.1-0.1,145.6c0,0.1,0,0.1,0.1,0.2c0.1-0.1,0.2-0.3,0.3-0.4 c2.8-0.5,2.3,1.9,2.6,3.2c1.9,10.7,8.4,17.9,17.5,23.1c37.1,21.3,74.1,42.8,111.3,63.9c14.8,8.4,30.7,8.9,45.4,0.6 c37.8-21.3,75.5-43.1,113-64.9c7.8-4.6,13.7-10.5,16.2-19.4c0.3-1.2,0.5-2.7,2.3-2.9c1,0.5,0.2,1.8,1,2.3 C323.4,260,323,258.9,325,259z"
}), React.createElement("path", {
  fill: "#D9D9D9",
  d: "M19,90c3.9-7.9,11.5-11.6,18.6-15.8c21-12.1,42-24.2,63-36.3c15.6-8.9,30.9-18.1,46.8-26.5 c16.7-8.8,33.2-6.9,49.2,2.5c20.8,12.2,41.7,24,62.5,36.1c17.5,10.2,35.4,19.6,52.4,30.7c7.9,5.2,12.4,12.7,13.5,22.2 c-1.8,0.1-1.8-0.7-1-2c-1,0.4-0.2,1.7-1.2,2.2c-2-0.3-2-2-2.4-3.4c-2.3-7.7-7.1-13.4-13.9-17.6c-14-8.7-28.5-16.6-42.7-24.9 c-23.2-13.5-46.5-26.7-69.7-40.1c-16-9.2-32.4-9.6-48.4-0.6c-22.7,12.7-45.1,25.7-67.5,38.8C65.5,62.8,52.8,70,40.1,77.3 c-5.3,3.1-10.8,6-15,10.7c-1.1,1.2-2.4,2.4-4.1,2.7C20.3,90.8,19.5,90.6,19,90z"
}), React.createElement("path", {
  fill: "#D6D6D6",
  d: "M323,103c0.1-0.7,0.3-1.5,0.4-2.2c0.5,0.7,1.1,1.4,1.6,2.2c1.5,3.2,2,6.6,2,10c0,45,0,89.9,0,134.9 c0,3.8-0.7,7.5-2,11.1c-0.5,0.7-1.1,1.4-1.6,2.2c-0.1-0.7-0.3-1.5-0.4-2.2c-1.2-1.7-0.9-3.5-0.6-5.3c1.2-7.3,1-14.6,1-21.9 c0-35.8,0-71.6,0-107.5c0-5.3,0.1-10.7-0.9-15.9C322.2,106.6,321.8,104.7,323,103z"
}), React.createElement("path", {
  fill: "#D9D9D9",
  d: "M19,90c0.7,0,1.4,0,2.1,0c0.9,3.6-1.4,5.9-3.6,8.2c-0.6-2.3-1.7,0.6-2.5-0.2c0,0,0,0,0,0 C15.2,94.8,16.4,92,19,90z"
}), React.createElement("path", {
  fill: "#FEFEFE",
  d: "M17,98c1.3-2.7,2.7-5.4,4-8c12.7-12.9,29.4-19.6,44.6-28.7c18.3-11,37-21.4,55.6-32.1 c9.1-5.2,18-10.8,27.3-15.4c15.2-7.4,30.6-6.6,45.2,1.7c23.8,13.5,47.5,27.3,71.2,41c13.4,7.7,26.7,15.5,40.1,23.1 c9.3,5.3,15.1,13.2,17.9,23.4c1.1,5.2,2,10.4,2,15.7c-0.1,41.5-0.1,83,0,124.5c0,5.3-1,10.5-2,15.7c-3.3,15.2-15.3,21.9-27.4,28.8 c-23.6,13.3-46.8,27.1-70.4,40.4c-12.9,7.2-25,16-38.7,21.4c-13.8,5.4-28,4.5-41.1-3c-26.3-14.9-52.4-30.1-78.6-45.2 c-11.5-6.6-23.2-12.9-34.5-19.9c-9.1-5.6-15.6-13.4-16.4-24.8c0-0.6-0.6-1.1-0.9-1.7c-1.6-1.6-1.5-3.6-1.5-5.6 c0-45.6,0-91.2,0-136.8c0-2-0.1-4,1.5-5.6c1.7-1.8,0.6-4,1-6C16,99.9,15.9,98.8,17,98z"
}), React.createElement("path", {
  fill: "#D6D6D6",
  d: "M15,107c-0.8,2.6-1,5.2-1,7.8c0,44.1,0,88.1,0,132.2c0,2.7,0.2,5.3,1,7.8c0,1.3,0,2.6,0,3.9 c-1.9-3.8-2-7.7-2-11.7c0-42.9,0-85.8,0-128.7c0-5.1-0.4-10.3,1.4-15.3C15.6,104.2,14.7,105.7,15,107z"
}), React.createElement("path", {
  fill: "#D9D9D9",
  d: "M17,98c0,1.1,0.1,2.2-1,3c-1.2-0.7-1-1.9-1-3C15.7,98.5,16.4,94.7,17,98z"
}), React.createElement("path", {
  fill: "#9A4F95",
  d: "M28.8,261.1c-2.8-3.9-3.7-8.5-3.7-13.2c0-44.7-0.1-89.3,0-134c0-10.2,4.6-18.4,13.5-23.6 C77.7,67.7,116.8,45.2,156,22.7c9.1-5.2,18.4-4.8,27.6,0.4c26,15,52,29.9,78,44.8c12.1,7,24.3,14,36.4,20.9 c5.1,2.9,9.8,6.4,12.2,12c-16.4,9.2-32.7,18.6-49,28c-2.6,1.5-5,4-8.6,2.9c-3.8-4.4-6.7-9.5-10.6-13.9 c-17.5-19.8-39.2-30.8-65.6-32.9c-47.2-3.8-86.7,27.1-98.6,67.5c-6.9,23.3-5.1,46,5.2,68.1c1.2,2.5,3.1,4.8,2.8,7.9 c-1.4,3-4.6,3.7-7.1,5.1c-14.9,8.6-29.7,17.4-44.8,25.7C32.2,260.3,30.9,261.9,28.8,261.1z"
}), React.createElement("path", {
  fill: "#68217A",
  d: "M28.8,261.1c18.8-10.7,37.6-21.5,56.4-32.2c2.5,0,3.1,2.3,4.2,3.8c17.3,24.5,40.4,39.4,70.5,42.1 c37.1,3.3,66.5-10.9,88.3-41c1.4-1.9,2.4-4.1,4.5-5.2c2-0.7,3.5,0.3,5.1,1.2c15.6,9.1,31.3,18,46.9,27c2,1.2,5.5,1.7,4.4,5.6 c-2.2,4.5-6,7.5-10.2,9.9c-38.5,22.2-77.1,44.4-115.6,66.5c-9.3,5.3-18.7,5.3-28,0c-38.7-22.2-77.4-44.5-116-66.8 C34.7,269.4,30.8,266.1,28.8,261.1z"
}), React.createElement("path", {
  fill: "#813786",
  d: "M309.2,262.4c-0.8-3.5-4.2-4-6.6-5.5c-15.3-9-30.7-17.8-46.2-26.7c-1-0.6-2.2-0.8-3.2-1.2 c-5.7-1.7-10.3-5.2-15.3-8.1c-6.9-4-13.8-7.9-20.7-12c-2.3-1.4-4.9-2-7.4-2.8c-4.6-5.3-11.4-7.3-17.1-10.9 c-8.1-4.9-16.2-9.7-24.7-14c-0.3-2.4,1.9-2.4,3.1-3.2c13.1-7.7,26.3-15.1,39.4-22.9c12.5-7.2,24.9-14.6,37.5-21.7 c1.5-0.9,2.9-2.4,5-1.5c17.4-9.9,34.8-19.8,52.1-29.8c1.6-0.9,2.9-2.3,4.9-1.3c3,4.5,3.6,9.6,3.6,14.8c0,43.5,0.1,87.1,0,130.6 C313.6,252.1,312.8,257.6,309.2,262.4z"
}), React.createElement("path", {
  fill: "#FEFEFE",
  d: "M253,132c-14,7.9-28,15.8-41.9,23.8c-2.1-0.4-2.8-2.2-3.9-3.6c-11.6-15.4-30.9-22.2-49.7-17.4 c-18.2,4.6-32.3,20.1-34.9,38.9c-1.5,10.8,0.4,21.2,6.2,30.7c12.2,20.6,37.1,27,57.7,19.6c8-2.9,14.1-8.5,19.8-14.7 c1.1-1.2,1.9-2.8,3.6-3.2c1.3-1.2,2.5-1.1,4-0.2c12.7,7.4,25.5,14.7,38.2,22.1c0.4,0.2,0.6,0.7,0.9,1.1 c-15.5,24.9-37.3,40.9-66.4,46.1c-39.8,7.2-78-9.8-99.8-43.9c-0.5-0.8-1.2-1.6-1.8-2.4c-6.5-12.7-11.5-25.8-12.4-40.2 c-2.5-38.4,12.3-68.7,44.3-89.8c44.3-29.3,105.5-15.6,134,29.2C251.8,129.3,252.4,130.7,253,132z"
}), React.createElement("path", {
  fill: "#9A4F95",
  d: "M128,205c-19-29.8,2-71,37.4-73c19.9-1.2,35.2,6.7,45.7,23.7c-8.6,6.4-18.5,10.8-27.6,16.4 c-5,3.1-10.3,5.9-15.4,8.8c-0.6,1.9-2.3,2.8-3.9,3.6c-11.5,6.5-22.9,13.1-34.3,19.8C129.3,204.8,128.6,205,128,205z"
}), React.createElement("path", {
  fill: "#68217A",
  d: "M128,205c4.6-5,11.1-7.1,16.7-10.7c7.6-4.8,15.6-8.9,23.4-13.4c6.5,0.9,11.3,5.3,16.7,8.2 c7.5,4.1,14.9,8.5,22.4,12.8c1.7,0.9,3.3,1.7,2.9,4c-9.4,14.8-23.2,22.3-40.5,22.3C151.5,228.3,137.5,220.5,128,205z"
}), React.createElement("path", {
  fill: "#FEFEFE",
  d: "M253.8,154.9c4.3-1.1,5.7,0.9,5.1,5c-0.4,2.6,0.8,3.6,3.4,3.4c1.5-0.1,3-0.2,4.5,0c3.9,0.5,6.1-0.6,5.3-5 c-0.7-4.1,2.3-3.6,4.8-3.5c2.4,0.1,6-1.2,5.3,3.4c-0.6,4.4,1.4,5.6,5.3,5c3.7-0.6,3.7,2,3.4,4.4c-0.3,2.2,1.7,6.2-3.1,5.6 c-5.4-0.7-6.2,2.1-5.6,6.4c0.1,1,0.1,2,0,3c-0.5,3.3,0.9,4.7,4.2,4.1c4.6-0.8,4.6,1.9,4.7,5.2c0.1,3.4-0.5,5.6-4.5,4.9 c-3.7-0.6-4.8,1.2-4.3,4.5c0.7,4.1-2,4.1-4.9,4c-2.9-0.1-6,0.4-5.2-4.1c0.6-3.5-0.9-4.9-4.4-4.4c-1.6,0.2-3.3,0.2-5,0 c-3.1-0.4-4.3,1-3.8,4c0.8,4.6-2.1,4.5-5.3,4.6c-3.5,0.1-5.5-0.5-4.9-4.6c0.6-3.5-1.3-4.5-4.3-4c-4.2,0.7-4.6-1.6-4.4-4.9 c0.2-2.8-0.5-6,4.1-5.2c3.8,0.7,5.2-1.1,4.7-4.7c-0.2-1.3-0.2-2.7,0-4c0.5-3.8-1-5.3-4.7-4.7c-4.7,0.7-3.9-2.6-4-5.3 c-0.1-3,0-5.4,4-4.8c3.1,0.5,5.3-0.3,4.7-4.2C248,154.9,250.3,154.4,253.8,154.9z"
}), React.createElement("path", {
  fill: "#833B89",
  d: "M258.8,179.6c0-6.3,0-6.3,7-6.3c7.5,0,6.2-0.4,6.2,7.5c0,6.9,0.7,5.9-7.3,5.9 C257.9,186.8,258.9,187.7,258.8,179.6z"
})));

var _ref13 =
/*#__PURE__*/
React.createElement("symbol", {
  id: "icon-SQL",
  viewBox: "0 0 267.2 330.5"
}, React.createElement("title", null, "SQL"), React.createElement("path", {
  id: "XMLID_74_",
  fill: "#75ADDE",
  d: "M335.5,222.3c-1.5,0.5-3.1,0.2-4.6,0.2c-0.1-0.1-0.1-0.1-0.1-0.2c0,0,0.1-0.1,0.1-0.1 C332.4,222.3,333.9,222.3,335.5,222.3z"
}), React.createElement("path", {
  id: "XMLID_73_",
  fill: "#75ADDE",
  d: "M347,222.5c-1.5,0-3.1,0.3-4.6-0.2c1.5,0,3,0,4.6,0C347.1,222.3,347.1,222.4,347,222.5 C347.1,222.5,347,222.5,347,222.5z"
}), React.createElement("path", {
  id: "XMLID_72_",
  fill: "#75ADDE",
  d: "M330.9,551.7c1.5,0,3.1-0.3,4.6,0.2c-1.5,0-3,0-4.6,0C330.8,551.9,330.8,551.8,330.9,551.7 C330.8,551.7,330.9,551.7,330.9,551.7z"
}), React.createElement("path", {
  id: "XMLID_71_",
  fill: "#75ADDE",
  d: "M342.4,551.9c1.5-0.5,3.1-0.2,4.6-0.2c0.1,0.1,0.1,0.1,0.1,0.2c0,0-0.1,0.1-0.1,0.1 C345.5,551.9,343.9,551.9,342.4,551.9z"
}), React.createElement("path", {
  id: "XMLID_70_",
  fill: "#B6D0ED",
  d: "M330.9,222.3c0,0.1,0,0.1,0,0.2c-1,0-1.9,0-2.9,0c0-0.1,0-0.1,0-0.2 C329,222.3,329.9,222.3,330.9,222.3z"
}), React.createElement("path", {
  id: "XMLID_69_",
  fill: "#B6D0ED",
  d: "M347,222.5c0-0.1,0-0.1,0-0.2c1,0,1.9,0,2.9,0c0,0.1,0,0.1,0,0.2 C348.9,222.5,348,222.5,347,222.5z"
}), React.createElement("path", {
  id: "XMLID_68_",
  fill: "#B6D0ED",
  d: "M330.9,551.7c0,0.1,0,0.1,0,0.2c-1,0-1.9,0-2.9,0c0-0.1,0-0.1,0-0.2 C329,551.7,329.9,551.7,330.9,551.7z"
}), React.createElement("path", {
  id: "XMLID_67_",
  fill: "#B6D0ED",
  d: "M347,551.9c0-0.1,0-0.1,0-0.2c1,0,1.9,0,2.9,0c0,0.1,0,0.1,0,0.2 C348.9,551.9,348,551.9,347,551.9z"
}), React.createElement("path", {
  id: "XMLID_66_",
  fill: "#B5CFEC",
  d: "M205.4,278.7c0.1,0,0.1,0,0.2,0c0,0.5,0,1,0,1.4c0,0.2-0.1,0.2-0.2,0 C205.4,279.7,205.4,279.2,205.4,278.7z"
}), React.createElement("path", {
  id: "XMLID_65_",
  fill: "#AFCCEB",
  d: "M472.3,278.7c0.1,0,0.1,0,0.2,0c0,0.5,0,1,0,1.4c-0.1,0.2-0.2,0.2-0.2,0 C472.3,279.6,472.3,279.2,472.3,278.7z"
}), React.createElement("path", {
  id: "XMLID_64_",
  fill: "#7BB0DF",
  d: "M205.4,280.1c0.1,0,0.1,0,0.2,0c0,0.5,0.1,1-0.2,1.5C205.4,281.1,205.4,280.6,205.4,280.1z"
}), React.createElement("path", {
  id: "XMLID_63_",
  fill: "#75AEDE",
  d: "M472.3,280.1c0.1,0,0.1,0,0.2,0c0,0.5,0,1,0,1.4C472.2,281.1,472.3,280.6,472.3,280.1z"
}), React.createElement("path", {
  id: "XMLID_62_",
  fill: "#8EBAE3",
  d: "M472.3,494.3c0-0.5-0.1-1,0.2-1.5c0,0.5,0,1,0,1.4C472.5,494.4,472.4,494.4,472.3,494.3z"
}), React.createElement("path", {
  id: "XMLID_61_",
  fill: "#B5CFEC",
  d: "M205.6,495.5c-0.1,0-0.1,0-0.2,0c0-0.5,0-1,0-1.4c0.1-0.2,0.2-0.2,0.2,0 C205.6,494.5,205.6,495,205.6,495.5z"
}), React.createElement("path", {
  id: "XMLID_60_",
  fill: "#7FB2E0",
  d: "M205.6,494.1c-0.1,0-0.1,0-0.2,0c0-0.4,0-0.8,0-1.2C205.7,493.2,205.6,493.6,205.6,494.1z"
}), React.createElement("path", {
  id: "XMLID_59_",
  fill: "#BAD2EE",
  d: "M472.3,494.3c0.1,0,0.1,0,0.2,0c0,0.4,0,0.8,0,1.2c-0.1,0-0.1,0-0.2,0 C472.3,495.1,472.3,494.7,472.3,494.3z"
}), React.createElement("path", {
  id: "XMLID_1_",
  fill: "#3B98D3",
  d: "M137.1,330.5c-2.3,0-4.6,0-7,0c-1.5-0.3-3,0-4.5-0.1c-0.9,0-1.8,0-2.7,0 c-5,0-10.1-0.1-15.1-0.4c-4.9-0.3-9.7-0.9-14.5-1.5c-6.6-0.9-13.1-2-19.6-3.3c-6.7-1.4-13.4-3.1-19.9-5.2c-7.6-2.4-14.9-5.2-22-8.8 c-5.1-2.6-9.9-5.5-14.4-9c-4.9-3.9-9.4-8.3-12.7-13.8c-2.6-4.4-4.6-8.9-4.5-14.2c0-0.4,0-0.9,0-1.3c-0.1-0.4,0.1-0.9-0.1-1.3 C0,201,0,130.6,0,60.2c0.3-0.5,0.1-1,0.1-1.5c0-0.5,0-0.9,0-1.4C0,52.2,2,47.6,4.5,43.3c3-5.1,7.1-9.3,11.7-13.1 c5.8-4.8,12.3-8.5,19.2-11.7c5.4-2.6,11-4.7,16.7-6.6c8.1-2.6,16.3-4.7,24.6-6.3c7-1.4,14.1-2.5,21.2-3.3c5.1-0.6,10.2-1.1,15.3-1.1 c3.2,0,6.5-0.2,9.7-0.2c0.9,0,1.8,0,2.7,0c1.5-0.1,3,0.1,4.5-0.1c2.3,0,4.6,0,7,0c1.5,0.3,3,0,4.5,0.1c0.9,0,1.8,0,2.7,0 c5,0,10.1,0.1,15.1,0.4c4.9,0.3,9.7,0.9,14.5,1.5c6.6,0.9,13.1,2,19.6,3.3c6.7,1.4,13.4,3.1,19.9,5.2c7.6,2.4,14.9,5.2,22,8.8 c5.1,2.6,9.9,5.5,14.4,9c4.9,3.9,9.4,8.3,12.7,13.8c2.6,4.4,4.6,8.9,4.5,14.2c0,0.5,0,0.9,0,1.4c0.1,0.5-0.1,1,0.1,1.5 c0,70.4,0,140.8,0,211.3c-0.3,0.5-0.1,1-0.1,1.5c0,0.4,0,0.8,0,1.2c0.1,5.2-1.9,9.8-4.5,14.2c-3,5.1-7.1,9.2-11.7,12.9 c-5.8,4.7-12.2,8.4-18.8,11.6c-5.5,2.6-11.2,4.8-16.9,6.7c-8.1,2.6-16.3,4.7-24.6,6.3c-7,1.4-14.1,2.5-21.2,3.3 c-5.1,0.6-10.2,1.1-15.3,1.1c-3.2,0-6.5,0.2-9.7,0.2c-0.9,0-1.8,0-2.7,0C140.1,330.4,138.6,330.2,137.1,330.5z M172.2,94.1 c10.5-1.5,21-3.5,31.2-6.5c9.4-2.8,18.6-6.3,26.9-11.5c4.3-2.7,8.2-5.7,11.1-10c2.4-3.5,2.4-7,0-10.5c-2.9-4.3-6.8-7.3-11-10 c-8.9-5.6-18.6-9.2-28.7-12c-18.2-5.2-36.9-7.6-55.7-8.4c-15.9-0.7-31.7-0.1-47.5,1.9c-10.6,1.3-21,3.2-31.3,6.1 c-10.6,3-20.9,6.6-30.3,12.5c-4.3,2.7-8.3,5.8-11.2,10.2c-2.2,3.3-2.2,6.7,0,10c1.8,2.8,4.1,5.1,6.7,7.1c6.1,4.8,13.1,8,20.2,10.8 c15.2,5.9,31,9,47,11c11.2,1.4,22.5,1.9,35.4,2C146.5,96.6,159.4,95.9,172.2,94.1z M24,97.3c0,11.6,0,23.2,0,34.8c0,1.4,0.4,2.8,1,4 c1.4,2.7,3.4,4.9,5.6,6.8c5.4,4.6,11.5,7.9,18,10.7c16.5,7,33.8,10.5,51.5,12.7c10.1,1.2,20.2,1.8,30.3,1.9 c10.3,0.1,20.6-0.3,30.9-1.3c11.4-1.1,22.7-2.8,33.8-5.6c11.3-2.8,22.4-6.4,32.6-12.2c4.9-2.7,9.4-5.9,12.9-10.4 c1.4-1.8,2.6-3.8,2.6-6.2c0-11.7,0-23.4,0-35.2c0-0.8-0.2-0.9-0.9-0.5c-1.4,0.9-2.9,1.7-4.3,2.5c-10.5,5.7-21.6,9.7-33.2,12.8 c-21.5,5.7-43.4,8.2-65.6,8.6c-12.6,0.2-25.3-0.3-37.9-1.6c-11.9-1.2-23.8-3.2-35.4-6.1c-12.3-3.1-24.3-7.1-35.6-13.1 c-2.1-1.1-4.1-2.3-6.3-3.5C24,96.8,24,97,24,97.3z M24,169.2c0,11.2,0,22.3,0,33.5c0,2.3,0.6,4.2,1.8,6.1c2.3,3.5,5.4,6.2,8.8,8.6 c8,5.5,16.9,9.1,26.1,12.1c19.5,6.2,39.5,8.9,59.8,9.8c13.2,0.6,26.3,0.3,39.4-0.9c9.9-0.9,19.8-2.3,29.5-4.4 c12.3-2.6,24.2-6.2,35.4-12c5.4-2.7,10.4-6,14.5-10.5c2.5-2.8,3.9-5.9,3.8-9.8c-0.2-10.8-0.1-21.7-0.1-32.5c0-0.4,0-0.8-0.1-1.4 c-0.9,0.6-1.7,1-2.5,1.5c-0.8,0.5-1.6,0.9-2.4,1.4c-10.6,5.8-21.9,9.9-33.6,12.9c-21.5,5.7-43.5,8.1-65.7,8.5 c-14.5,0.3-29-0.5-43.4-2.3c-11.7-1.5-23.3-3.6-34.7-6.8c-12.6-3.5-24.8-8-36-14.9c-0.2-0.1-0.4-0.3-0.8-0.2 C24,168.4,24,168.8,24,169.2z M24,240.7c0,9.6,0,19.3,0,28.9c0,2.3,0.6,4.3,1.9,6.2c2.8,4.3,6.8,7.3,11,10c8.9,5.6,18.6,9.2,28.7,12 c18.2,5.2,36.9,7.6,55.7,8.4c12.7,0.6,25.4,0.2,38.1-0.9c10.4-0.9,20.7-2.4,30.9-4.6c11.9-2.6,23.6-6.2,34.5-11.8 c5.4-2.7,10.4-5.9,14.5-10.5c2.6-2.8,4-6,3.9-10c-0.2-9.3-0.1-18.6-0.1-27.8c0-0.4,0.1-0.9-0.2-1.4c-0.3,0.2-0.6,0.3-0.8,0.4 c-10.3,6.3-21.5,10.6-33,14c-22.8,6.6-46.2,9.4-69.9,9.8c-16.8,0.3-33.5-0.6-50.1-3.1c-11.3-1.7-22.4-4-33.3-7.3 c-9.4-2.9-18.5-6.4-27.1-11.1c-1.5-0.8-3-1.8-4.8-2.8C24,239.8,24,240.3,24,240.7z"
}));

var _ref14 =
/*#__PURE__*/
React.createElement("symbol", {
  id: "icon-geo-json",
  viewBox: "0 0 315.2 349"
}, React.createElement("path", {
  id: "XMLID_1_",
  fill: "#1E6734",
  d: "M303.2,349H12c-6.6,0-12-4.7-12-10.5V10.5C0,4.7,5.4,0,12,0h229.8l73.4,67.7v270.9 C315.2,344.3,309.8,349,303.2,349z"
}), React.createElement("polygon", {
  id: "XMLID_2_",
  fill: "#6DBE45",
  points: "271.3,27.3 241.8,0 242.3,66.5 315.2,67.7 "
}), React.createElement("g", {
  id: "XMLID_25_"
}, React.createElement("path", {
  id: "XMLID_28_",
  fill: "#FFFFFF",
  d: "M68.4,247.6v54.3c0,7.1-0.5,12.2-1.4,15.1c-0.9,2.9-2.7,5.2-5.4,6.9 c-2.7,1.7-6,2.5-10.2,2.5c-1.5,0-3.1-0.1-4.8-0.4s-3.5-0.7-5.5-1.2l2.6-12.7c0.7,0.1,1.4,0.3,2,0.3c0.6,0.1,1.2,0.1,1.7,0.1 c1.5,0,2.8-0.3,3.7-1c1-0.7,1.6-1.4,1.9-2.3c0.3-0.9,0.5-3.7,0.5-8.2v-53.4H68.4z M53.6,240v-13.7h14.8V240H53.6z"
}), React.createElement("path", {
  id: "XMLID_32_",
  fill: "#FFFFFF",
  d: "M78.7,287.6l14.9-2.3c0.6,2.9,1.9,5.1,3.8,6.6c1.9,1.5,4.6,2.2,8.1,2.2 c3.8,0,6.7-0.7,8.6-2.1c1.3-1,2-2.3,2-4c0-1.1-0.4-2.1-1.1-2.8c-0.7-0.7-2.4-1.4-5-2c-12-2.6-19.5-5-22.7-7.2 c-4.4-3-6.6-7.2-6.6-12.6c0-4.9,1.9-8.9,5.7-12.2c3.8-3.3,9.8-5,17.8-5c7.7,0,13.4,1.2,17.1,3.7c3.7,2.5,6.3,6.2,7.7,11.1l-14,2.6 c-0.6-2.2-1.7-3.8-3.4-5c-1.7-1.2-4.1-1.7-7.1-1.7c-3.9,0-6.7,0.5-8.4,1.6c-1.1,0.8-1.7,1.8-1.7,3c0,1.1,0.5,2,1.5,2.7 c1.3,1,5.9,2.4,13.8,4.2c7.9,1.8,13.4,4,16.5,6.6c3.1,2.6,4.6,6.3,4.6,11c0,5.1-2.1,9.5-6.4,13.2c-4.3,3.7-10.6,5.5-19,5.5 c-7.6,0-13.7-1.5-18.1-4.6C83,297.1,80,292.9,78.7,287.6z"
}), React.createElement("path", {
  id: "XMLID_34_",
  fill: "#FFFFFF",
  d: "M140.5,274.8c0-4.9,1.2-9.7,3.6-14.3c2.4-4.6,5.9-8.1,10.3-10.5c4.4-2.4,9.4-3.6,14.9-3.6 c8.5,0,15.4,2.8,20.8,8.3c5.4,5.5,8.1,12.5,8.1,20.9c0,8.5-2.7,15.5-8.2,21.1c-5.5,5.6-12.3,8.4-20.6,8.4c-5.1,0-10-1.2-14.7-3.5 c-4.7-2.3-8.2-5.7-10.6-10.2S140.5,281.2,140.5,274.8z M155.7,275.6c0,5.6,1.3,9.8,4,12.8s5.9,4.4,9.8,4.4c3.9,0,7.1-1.5,9.7-4.4 s3.9-7.2,3.9-12.9c0-5.5-1.3-9.7-3.9-12.7s-5.9-4.4-9.7-4.4c-3.9,0-7.1,1.5-9.8,4.4S155.7,270,155.7,275.6z"
}), React.createElement("path", {
  id: "XMLID_37_",
  fill: "#FFFFFF",
  d: "M260.9,303.6h-14.8V275c0-6-0.3-10-0.9-11.7c-0.6-1.8-1.7-3.2-3.1-4.1 c-1.4-1-3.1-1.5-5.1-1.5c-2.6,0-4.9,0.7-6.9,2.1c-2,1.4-3.4,3.3-4.2,5.6c-0.8,2.3-1.1,6.6-1.1,12.9v25.4h-14.8v-56h13.8v8.2 c4.9-6.3,11-9.5,18.5-9.5c3.3,0,6.3,0.6,9,1.8c2.7,1.2,4.8,2.7,6.1,4.5c1.4,1.8,2.4,3.9,2.9,6.2c0.5,2.3,0.8,5.6,0.8,10V303.6z"
})), React.createElement("g", {
  id: "XMLID_26_"
}, React.createElement("g", {
  id: "XMLID_27_"
}, React.createElement("polygon", {
  id: "XMLID_24_",
  fill: "#FFFFFF",
  points: "206.5,83.6 206.7,85.1 204.3,85.6 204,88.8 206.8,88.8 210.6,88.4 212.6,86.2  210.5,85.4 209.4,84.2 207.7,81.6 206.8,77.8 203.6,78.4 202.7,79.8 202.7,81.2 204.3,82.3 \t\t"
}), React.createElement("polygon", {
  id: "XMLID_23_",
  fill: "#FFFFFF",
  points: "203.7,84.8 203.9,82.8 202,82 199.4,82.6 197.4,85.6 197.4,87.5 199.7,87.5 \t\t"
}), React.createElement("path", {
  id: "XMLID_22_",
  fill: "#FFFFFF",
  d: "M149.4,93.4l-0.6,1.4h-2.8v1.4h0.7c0,0,0,0.3,0.1,0.7l1.7-0.1l1.1-0.6l0.3-1.3l1.4-0.1 l0.5-1.1l-1.3-0.3L149.4,93.4z"
}), React.createElement("polygon", {
  id: "XMLID_21_",
  fill: "#FFFFFF",
  points: "142.2,95.9 142.1,97.3 144.1,97.1 144.3,95.7 143.1,94.8 \t\t"
}), React.createElement("path", {
  id: "XMLID_29_",
  fill: "#FFFFFF",
  d: "M264.5,139.1c0-3-0.2-5.9-0.5-8.8c-1-9.7-3.4-19-7.1-27.7c-0.3-0.6-0.5-1.3-0.8-1.9 c-4.9-10.9-11.7-20.9-20-29.5c-0.5-0.6-1.1-1.1-1.7-1.7c-1.6-1.6-3.2-3.1-4.9-4.5c-19-16.5-44.2-26.5-71.9-26.5 c-27.9,0-53.3,10.2-72.4,27C80.8,69.1,76.7,73.4,73,78c-14,17.2-22.3,38.8-22.3,62.2c0,56.2,48,101.9,106.9,101.9 c41.5,0,77.5-22.6,95.2-55.6c3.8-7,6.7-14.6,8.7-22.4c0.5-2,0.9-4,1.3-6c1.1-5.8,1.7-11.7,1.7-17.8 C264.5,139.8,264.5,139.4,264.5,139.1z M244.3,98.4l0.6-0.7c0.8,1.5,1.6,3,2.3,4.6l-1,0l-1.9,0.3V98.4z M228.9,80.6l0-4.5 c1.7,1.7,3.3,3.4,4.8,5.3l-1.9,2.7l-6.7-0.1l-0.4-1.3L228.9,80.6z M100,69.3v-0.2h2.1l0.2-0.7h3.5v1.5l-1,1.3h-4.8L100,69.3 L100,69.3z M103.4,73.8c0,0,2.1-0.3,2.3-0.3c0.2,0,0,2,0,2l-4.8,0.3l-0.9-1L103.4,73.8z M251.1,114.3h-7.8l-4.8-3.4l-5,0.5v2.9 H232l-1.7-1.2l-8.7-2.1v-5.4l-11,0.8l-3.4,1.7h-4.4l-2.1-0.2l-5.3,2.8v5.3l-10.8,7.5l0.9,3.2h2.2l-0.6,3l-1.5,0.5l-0.1,7.9 l9.4,10.2h4.1l0.2-0.6h7.3l2.1-1.9h4.2l2.3,2.2l6.2,0.6l-0.8,7.9l6.9,11.6l-3.6,6.6l0.2,3.1l2.9,2.7v7.5l3.7,4.8v6.2h3.2 c-18,21.1-45.4,34.6-76.1,34.6c-54.1,0-98.1-41.9-98.1-93.5c0-13,2.8-25.3,7.8-36.6v-2.9l3.5-4.1c1.2-2.2,2.5-4.3,3.9-6.4l0.2,1.7 l-4.1,4.7c-1.3,2.3-2.4,4.6-3.5,7v5.3l4.1,1.9v7.4l3.9,6.4l3.2,0.5l0.4-2.2l-3.8-5.5l-0.7-5.4h2.2l0.9,5.5l5.4,7.5l-1.4,2.4l3.4,5 l8.6,2v-1.3l3.4,0.5l-0.3,2.3l2.7,0.5l4.2,1.1l5.9,6.4l7.5,0.5l0.7,5.8l-5.1,3.4l-0.2,5.2l-0.7,3.2l7.4,8.9l0.6,3 c0,0,2.7,0.7,3,0.7c0.3,0,6,4.1,6,4.1v16l2,0.5l-1.4,7.4l3.4,4.4l-0.6,7.3l4.5,7.6l5.8,4.8l5.8,0.1l0.6-1.8l-4.3-3.4l0.2-1.7 l0.8-2.1l0.2-2.1l-2.9-0.1l-1.5-1.8l2.4-2.2l0.3-1.7l-2.7-0.7l0.2-1.6l3.8-0.6l5.8-2.7l2-3.4l6.1-7.5l-1.4-5.8l1.9-3.1l5.6,0.2 l3.8-2.9l1.2-11.3l4.2-5.1l0.7-3.3l-3.8-1.2l-2.5-4l-8.6-0.1l-6.8-2.5l-0.3-4.7l-2.3-3.8l-6.2-0.1l-3.6-5.4l-3.2-1.5l-0.2,1.6 l-5.8,0.3l-2.1-2.8l-6-1.2l-5,5.5l-7.8-1.3l-0.6-8.4l-5.7-0.9l2.3-4.1l-0.7-2.4l-7.5,4.8l-4.7-0.5l-1.7-3.5l1-3.6l2.6-4.6l6-2.9 l11.6,0l0,3.4l4.2,1.8l-0.3-5.7l3-2.9l6-3.8l0.4-2.7l6-6l6.4-3.4l-0.6-0.4l4.3-3.9l1.6,0.4l0.7,0.9l1.6-1.7l0.4-0.2l-1.8-0.2 l-1.8-0.6v-1.7l1-0.8h2.1l1,0.4l0.8,1.6l1-0.2v-0.1l0.3,0.1l3-0.4l0.4-1.4l1.7,0.4v1.5l-1.6,1h0l0.2,1.7l5.4,1.6c0,0,0,0,0,0.1 l1.3-0.1l0.1-2.2l-4.3-1.9l-0.2-1.1l3.6-1.2l0.2-3.3l-3.7-2.2l-0.2-5.5l-5.1,2.4h-1.9l0.5-4.2l-7-1.6l-2.9,2.1v6.4l-5.2,1.6 l-2.1,4.1l-2.3,0.3v-5.3l-4.9-0.6l-2.4-1.5l-1-3.4l8.7-4.9l4.3-1.2l0.4,2.7l2.4-0.1l0.2-1.4l2.5-0.3l0-0.5l-1.1-0.4l-0.2-1.5 l3.1-0.2l1.9-1.8l0.1-0.1l0,0l0.6-0.6l6.4-0.8l2.8,2.3l-7.5,3.8l9.5,2.1l1.2-3h4.2l1.5-2.6l-2.9-0.7v-3.3l-9.2-3.9l-6.4,0.7 l-3.6,1.8l0.2,4.3l-3.8-0.5l-0.6-2.4l3.6-3.1l-6.5-0.3l-1.9,0.5l-0.8,2.1l2.4,0.4l-0.5,2.3l-4.2,0.2L128,68l-6,0.2 c0,0-0.2-3.3-0.4-3.3s4.7-0.1,4.7-0.1l3.6-3.3l-2-0.9l-2.6,2.4l-4.3-0.2l-2.6-3.4h-5.5l-5.8,4.1h5.3l0.5,1.5l-1.4,1.2l5.9,0.2 l0.9,2l-6.6-0.2l-0.3-1.6l-4.2-0.9l-2.2-1.2l-4.9,0c16.2-11.2,36.1-17.9,57.6-17.9c24.8,0,47.5,8.8,64.8,23.4l-1.2,2l-4.5,1.7 l-1.9,2l0.4,2.3l2.3,0.3l1.4,3.4l4-1.5l0.7,4.5h-1.2l-3.3-0.5l-3.7,0.6l-3.5,4.8l-5.1,0.8l-0.7,4.1l2.1,0.5l-0.6,2.7l-5-1l-4.6,1 l-1,2.5l0.8,5.1l2.7,1.2l4.6,0l3.1-0.3l0.9-2.3l4.8-5.9l3.2,0.6l3.1-2.7l0.6,2.1l7.7,4.9l-0.9,1.2l-3.5-0.2l1.3,1.8l2.1,0.4l2.5-1 l-0.1-2.9l1.1-0.5l-0.9-0.9L225,98l-1.3-3.6h4.2l1.4,1.3l3.7,3l0.2,3.6l3.8,3.8l1.4-5.3l2.6-1.4l0.5,4.3l2.6,2.7l5.1-0.1 c1,2.4,1.9,4.9,2.7,7.4L251.1,114.3z M109,84.5l2.6-1.2l2.3,0.5l-0.8,3l-2.5,0.8L109,84.5z M122.6,91.5v1.9h-5.9l-2.2-0.6l0.5-1.3 l2.8-1.1h3.9v1.1H122.6z M125.3,94.2v1.9l-1.5,0.9l-1.8,0.3c0,0,0-2.8,0-3.1H125.3z M123.7,93.5v-2.2l2,1.8L123.7,93.5z M124.6,97.9v1.8l-1.4,1.3h-3.1l0.5-2l1.5-0.1l0.3-0.7L124.6,97.9z M116.8,94.2h3.2l-4.2,5.5l-1.7-0.9l0.4-2.3L116.8,94.2z M130.1,97.3v1.8H127l-0.9-1.2v-1.7h0.2L130.1,97.3z M127.2,94.8l0.9-0.9l1.5,0.9l-1.2,0.9L127.2,94.8z M252.7,119l0.3-0.3 c0.1,0.5,0.3,1.1,0.4,1.6L252.7,119z"
}), React.createElement("path", {
  id: "XMLID_5_",
  fill: "#FFFFFF",
  d: "M67.3,100.6v2.9c1.1-2.4,2.2-4.7,3.5-7L67.3,100.6z"
}))));

var _ref15 =
/*#__PURE__*/
React.createElement("symbol", {
  id: "icon-json",
  viewBox: "0 0 315.2 349"
}, React.createElement("path", {
  id: "XMLID_1_",
  fill: "#1E6734",
  d: "M303.2,349H12c-6.6,0-12-4.7-12-10.5V10.5C0,4.7,5.4,0,12,0h229.8l73.4,67.7v270.9 C315.2,344.3,309.8,349,303.2,349z"
}), React.createElement("polygon", {
  id: "XMLID_2_",
  fill: "#6DBE45",
  points: "271.3,27.3 241.8,0 242.3,66.5 315.2,67.7 "
}), React.createElement("g", {
  id: "XMLID_5_"
}, React.createElement("path", {
  id: "XMLID_6_",
  fill: "#FFFFFF",
  d: "M6.3,185.6v-19.1c3.5-0.2,6.1-0.8,7.9-1.8c1.8-1,3.3-2.6,4.6-4.8c1.3-2.3,2.2-5.1,2.6-8.5 c0.4-2.6,0.6-7,0.6-13.3c0-10.3,0.4-17.5,1.3-21.6c0.9-4.1,2.4-7.3,4.6-9.8c2.2-2.5,5.5-4.4,9.8-5.9c2.9-1,7.5-1.4,13.7-1.4h3.8 v19.1c-5.3,0-8.7,0.3-10.2,1c-1.5,0.7-2.6,1.7-3.3,3c-0.7,1.4-1.1,3.7-1.1,7c0,3.3-0.2,9.7-0.6,19.1c-0.2,5.3-0.9,9.5-1.9,12.8 c-1,3.3-2.3,6-3.8,8.1c-1.5,2.1-3.9,4.3-7.1,6.6c2.8,1.8,5.1,3.9,6.9,6.3c1.8,2.4,3.2,5.4,4.1,8.8c1,3.5,1.6,8.1,1.9,13.9 c0.3,8.8,0.5,14.5,0.5,16.9c0,3.5,0.4,6,1.1,7.3c0.8,1.4,1.9,2.4,3.5,3.1c1.5,0.7,4.9,1.1,10,1.1v19.1h-3.8 c-6.4,0-11.4-0.6-14.8-1.7c-3.4-1.1-6.3-3-8.7-5.7c-2.4-2.7-3.9-5.9-4.8-9.8c-0.8-3.9-1.2-10.1-1.2-18.5c0-9.8-0.4-16.1-1.1-19 c-1-4.3-2.6-7.3-4.8-9.1C14,186.9,10.7,185.8,6.3,185.6z"
}), React.createElement("path", {
  id: "XMLID_8_",
  fill: "#FFFFFF",
  d: "M82.9,147.6v53.8c0,7.1-0.4,12.1-1.2,15c-0.8,2.9-2.4,5.2-4.8,6.8c-2.4,1.6-5.4,2.5-9,2.5 c-1.3,0-2.7-0.1-4.2-0.4c-1.5-0.3-3.1-0.7-4.9-1.2l2.3-12.5c0.6,0.1,1.2,0.3,1.8,0.3c0.5,0.1,1.1,0.1,1.5,0.1c1.3,0,2.4-0.3,3.3-1 c0.9-0.6,1.4-1.4,1.7-2.3c0.3-0.9,0.4-3.6,0.4-8.2v-53H82.9z M69.7,140v-13.6h13.2V140H69.7z"
}), React.createElement("path", {
  id: "XMLID_11_",
  fill: "#FFFFFF",
  d: "M92,187.2l13.2-2.2c0.6,2.9,1.7,5,3.4,6.5c1.7,1.5,4.1,2.2,7.2,2.2c3.4,0,6-0.7,7.7-2.1 c1.2-1,1.7-2.3,1.7-3.9c0-1.1-0.3-2-0.9-2.8c-0.7-0.7-2.1-1.3-4.4-1.9c-10.6-2.6-17.4-5-20.2-7.2c-3.9-3-5.9-7.2-5.9-12.5 c0-4.8,1.7-8.9,5.1-12.1c3.4-3.3,8.7-4.9,15.8-4.9c6.8,0,11.9,1.2,15.2,3.7c3.3,2.5,5.6,6.1,6.8,11l-12.4,2.6c-0.5-2.2-1.5-3.8-3-5 c-1.5-1.2-3.6-1.7-6.3-1.7c-3.5,0-6,0.5-7.4,1.6c-1,0.8-1.5,1.8-1.5,3c0,1,0.4,1.9,1.3,2.7c1.2,1,5.3,2.4,12.3,4.1 c7,1.8,11.9,4,14.7,6.5c2.7,2.6,4.1,6.3,4.1,10.9c0,5.1-1.9,9.5-5.7,13.1c-3.8,3.7-9.4,5.5-16.9,5.5c-6.8,0-12.1-1.5-16.1-4.6 C95.8,196.7,93.3,192.5,92,187.2z"
}), React.createElement("path", {
  id: "XMLID_13_",
  fill: "#FFFFFF",
  d: "M147,174.5c0-4.9,1.1-9.6,3.2-14.2c2.2-4.6,5.2-8.1,9.2-10.5c4-2.4,8.4-3.6,13.2-3.6 c7.5,0,13.7,2.7,18.5,8.2c4.8,5.5,7.2,12.3,7.2,20.7c0,8.4-2.4,15.4-7.3,20.9c-4.9,5.5-11,8.3-18.3,8.3c-4.6,0-8.9-1.2-13-3.5 c-4.1-2.3-7.3-5.7-9.4-10.1C148.1,186.3,147,180.9,147,174.5z M160.5,175.3c0,5.5,1.2,9.7,3.5,12.7s5.2,4.4,8.7,4.4 s6.3-1.5,8.6-4.4c2.3-2.9,3.5-7.2,3.5-12.8c0-5.4-1.2-9.6-3.5-12.5c-2.3-2.9-5.2-4.4-8.6-4.4s-6.3,1.5-8.7,4.4 C161.7,165.6,160.5,169.8,160.5,175.3z"
}), React.createElement("path", {
  id: "XMLID_16_",
  fill: "#FFFFFF",
  d: "M253.9,203.1h-13.2v-28.3c0-6-0.3-9.9-0.8-11.6c-0.6-1.8-1.5-3.1-2.7-4.1 c-1.3-1-2.8-1.5-4.6-1.5c-2.3,0-4.3,0.7-6.1,2.1c-1.8,1.4-3.1,3.2-3.7,5.5c-0.7,2.3-1,6.6-1,12.8v25.1h-13.2v-55.5h12.2v8.2 c4.3-6.3,9.8-9.4,16.4-9.4c2.9,0,5.6,0.6,8,1.8c2.4,1.2,4.2,2.7,5.5,4.5c1.2,1.8,2.1,3.9,2.6,6.2c0.5,2.3,0.7,5.6,0.7,9.9V203.1z"
}), React.createElement("path", {
  id: "XMLID_18_",
  fill: "#FFFFFF",
  d: "M308.3,185.6c-3.5,0.2-6.1,0.8-7.9,1.8c-1.8,1-3.3,2.6-4.5,4.8c-1.3,2.3-2.2,5.1-2.7,8.5 c-0.4,2.6-0.6,7-0.6,13.2c0,10.3-0.4,17.5-1.3,21.6c-0.8,4.1-2.4,7.4-4.6,9.8c-2.2,2.5-5.5,4.4-9.9,5.9c-2.9,1-7.5,1.4-13.7,1.4 h-3.8v-19.1c5.1,0,8.4-0.4,10-1.1c1.6-0.7,2.7-1.8,3.5-3.1c0.7-1.4,1.1-3.7,1.1-6.9c0-3.2,0.2-9.4,0.6-18.6 c0.2-5.5,0.9-10,1.9-13.3c1-3.3,2.4-6.1,4.2-8.4c1.7-2.3,4-4.3,6.7-6.1c-3.5-2.5-6.1-5-7.7-7.5c-2.2-3.5-3.8-8-4.6-13.4 c-0.5-3.7-0.9-11.9-1.1-24.5c0-4-0.4-6.6-1-8c-0.6-1.3-1.7-2.4-3.2-3.1c-1.5-0.7-5-1.1-10.4-1.1V99.4h3.8c6.4,0,11.4,0.6,14.8,1.7 c3.4,1.1,6.3,3,8.6,5.7c2.3,2.7,3.9,6,4.8,9.9c0.8,3.9,1.3,10.1,1.3,18.5c0,9.7,0.4,16.1,1.1,19.1c1,4.3,2.6,7.3,4.8,9.1 c2.1,1.8,5.4,2.9,9.8,3.1V185.6z"
})));

var _ref16 =
/*#__PURE__*/
React.createElement("symbol", {
  id: "icon-arduino",
  viewBox: "0 0 186 186"
}, React.createElement("title", null, "c"), React.createElement("circle", {
  fill: "#048890",
  cx: 93,
  cy: 93,
  r: 93
}), React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  fill: "none",
  d: "M48.9,119.1c-10.3-1-19.5-5.7-24.1-16.5c-4-9.3-2.5-18.5,4.3-26c7.3-8.1,16.5-11,27.5-8.6 c13.1,2.9,20.6,12.3,27.3,22.9c0.7,1.1,1.1,2.3,0.3,3.7C77.2,107.1,65.6,118.8,48.9,119.1z M51.3,97.1c3,0,6-0.2,9,0.1 c3.1,0.3,3.7-1.1,3.4-3.8c-0.2-2.3,0.6-4.6-3.3-4.4c-5.6,0.3-11.3,0.2-17,0c-2.9-0.1-4.9-0.1-4.9,4c0,3.9,1.7,4.3,4.7,4.1 C46,96.9,48.7,97.1,51.3,97.1z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M173.7,75c-8.4-17.1-32.3-26.9-50.3-20.6C110.6,58.8,101,67,93.2,78.1c-1-1.3-1.9-2.5-2.8-3.7 c-16.2-21.3-42-28.9-64-14.7C8.3,71.5,3.9,92.4,11.9,109.4c11.9,25.2,43.4,31.7,65.6,14.8c6-4.5,10.9-10,15.5-16 c2.9,3.4,5.5,6.7,8.4,9.7c15.6,16.5,38.8,20.2,57.2,9.2C176,116.8,183.3,94.4,173.7,75z M84.1,94.6c-6.9,12.6-18.6,24.2-35.3,24.5 c-10.3-1-19.5-5.7-24.1-16.5c-4-9.3-2.5-18.5,4.3-26c7.3-8.1,16.5-11,27.5-8.6c13.1,2.9,20.6,12.3,27.3,22.9 C84.5,92,84.9,93.2,84.1,94.6z M151,114.7c-4.5,3-9.7,4.3-15.1,4.5c-12.3-0.9-21.7-7-28.6-16.8c-8.2-11.5-7.9-7.4,0-18.8 c6.8-9.7,16.1-16.3,28.6-16.5c12.5-0.2,23,7.6,26.7,19.3C165.9,96.5,161.2,107.9,151,114.7z"
})), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M51.4,97.9c-3.2,0-6.3-0.2-9.5,0c-3.7,0.3-5.6-0.2-5.6-4.9c0-4.9,2.3-4.8,5.8-4.7 c6.7,0.2,13.5,0.3,20.2-0.1c4.6-0.3,3.7,2.5,4,5.2c0.3,3.1-0.4,4.8-4.1,4.5C58.5,97.6,54.9,97.9,51.4,97.9z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M134.4,108.3c-4.5,1.1-5-1.7-4.5-5c0.7-4.4-1-6.2-5.4-5.4c-4,0.8-5-1.2-4.9-4.9c0-3.5,0.8-5.3,4.6-4.6 c4.6,0.8,6.5-1,5.7-5.7c-0.7-3.9,0.9-5.1,4.8-5c3.7,0.1,6.3,0.4,5.5,5c-0.9,4.8,1.3,6.4,5.8,5.6c3.9-0.6,4,1.7,4,4.6 c0,3.1,0,5.7-4.2,4.9c-4.2-0.7-6.4,0.7-5.6,5.3C141.1,108,138.6,109.1,134.4,108.3z"
})), React.createElement("symbol", {
  id: "icon-c",
  viewBox: "-34 23 178 156.3",
  xmlSpace: "preserve"
}, React.createElement("path", {
  id: "XMLID_3_",
  fill: "#ED1F2F",
  stroke: "#ED1F2F",
  strokeWidth: 13,
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  d: " M96.8,29.6H14.1l-41.4,71.7l41.4,71.7h82.7l41.4-71.7L96.8,29.6z"
}), React.createElement("path", {
  id: "XMLID_21_",
  fill: "#4582C3",
  stroke: "#231F20",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M94,34H16.7L-22,101l38.7,67H94 l38.7-67L94,34z M87.9,72.2c-5.8-1.6-11.3-2.4-16.5-2.4c-7.9,0-14.5,2.9-19.7,8.8c-5.2,5.9-7.8,13.3-7.8,22.4 c0,9.8,2.6,17.5,7.9,23.2c5.2,5.8,12.2,8.6,21,8.6c4.3,0,9.3-0.8,15.1-2.4v25.8c-6.4,1.7-12.2,2.5-17.3,2.5 c-17.6,0-31.9-5.4-42.9-16.1c-11-10.7-16.4-24.9-16.4-42.4c0-16.3,5.5-29.7,16.6-40.2c11.1-10.6,25-15.9,41.9-15.9 c6.6,0,12.6,0.7,18.1,2.1V72.2z"
}), React.createElement("g", null, React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M84.7,120.1c-0.6,0-0.9,0.2-1.3,0.7 c-0.3,0.5-0.5,1.2-0.5,2c0,1.6,0.5,2.4,1.4,2.4c0.7,0,1.4-0.5,1.9-1.3V121h0.1C85.9,120.4,85.3,120.1,84.7,120.1z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M77.4,120.1c-0.5,0-0.9,0.2-1.1,0.6 c-0.3,0.3-0.5,0.8-0.6,1.5h3.2v-0.2C78.9,120.7,78.4,120.1,77.4,120.1z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M103.5,70.7c-0.6,0-0.9,0.2-1.3,0.6 s-0.7,0.9-0.7,1.6h3.5v-0.2C105.1,71.4,104.5,70.7,103.5,70.7z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M99,132.5c-0.6,0-1.1,0.2-1.5,0.7 c-0.3,0.5-0.6,1-0.7,1.9h4.1v-0.2C101,133.3,100.3,132.5,99,132.5z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M113.3,71.7c-0.6-0.7-1.3-1-1.8-1 s-1,0.2-1.4,0.8s-0.5,1.3-0.5,2.1s0.1,1.4,0.5,1.9c0.3,0.5,0.7,0.7,1.1,0.7c0.7-0.1,1.4-0.6,2.1-1.5V71.7z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M50.1,160.1c0,0.6,0.2,1,0.6,1.4 c0.3,0.3,0.8,0.5,1.5,0.5c0.9,0,1.8-0.5,2.9-1.3v-2.9h-0.6C51.5,157.7,50.1,158.6,50.1,160.1z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M10.3,116.1c0.6,0,1-0.2,1.4-0.7 c0.3-0.5,0.5-1.2,0.5-2s-0.1-1.5-0.5-2s-0.8-0.7-1.4-0.7c-0.6,0-1,0.2-1.4,0.7c-0.3,0.5-0.5,1-0.5,2c0,0.8,0.1,1.5,0.5,2 C9.2,115.9,9.7,116.1,10.3,116.1z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M2.8,110.9c-0.5,0-0.9,0.2-1.1,0.6 c-0.3,0.3-0.5,0.8-0.6,1.5h3.2v-0.2C4.3,111.5,3.8,110.9,2.8,110.9z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M110.2,133.4c-0.3-0.6-1-0.9-1.7-0.9 c-0.7,0-1.4,0.3-1.7,0.9c-0.3,0.6-0.6,1.4-0.6,2.4s0.2,1.9,0.6,2.4c0.3,0.6,1,0.9,1.7,0.9c0.7,0,1.4-0.3,1.7-0.9 c0.3-0.6,0.6-1.4,0.6-2.4S110.6,134,110.2,133.4z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M-6.6,101c0,0.3,0.1,0.6,0.3,0.8 c0.2,0.2,0.5,0.3,0.8,0.3c0.6-0.1,1.1-0.3,1.7-0.8v-1.7H-4C-5.8,99.6-6.6,100.1-6.6,101z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M26.8,162.2c1,0,1.8-0.3,2.4-1.2 c0.6-0.8,0.8-1.9,0.8-3.4c0-1.4-0.2-2.6-0.8-3.4c-0.6-0.8-1.4-1.2-2.4-1.2s-1.8,0.3-2.4,1.2s-0.8,1.9-0.8,3.4 c0,1.4,0.2,2.6,0.8,3.4C25,161.7,25.8,162.2,26.8,162.2z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M102,58.5c-0.5,0-0.8,0.2-1.1,0.6 c-0.2,0.3-0.5,0.9-0.5,1.6s0.1,1.2,0.5,1.6c0.2,0.3,0.7,0.6,1.1,0.6s0.8-0.2,1.1-0.6c0.2-0.3,0.5-0.9,0.5-1.6s-0.1-1.2-0.5-1.6 C102.9,58.7,102.4,58.5,102,58.5z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M108.8,83.7c-0.3,0.5-0.5,1.2-0.5,2 c0,1.6,0.5,2.4,1.4,2.4c0.7,0,1.4-0.5,1.9-1.3v-2.9h0.1c-0.6-0.6-1.1-0.9-1.7-0.9C109.5,83,109.2,83.2,108.8,83.7z"
}), React.createElement("polygon", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  points: "24.4,59.5 23.4,59.5 23.1,60.8  24.1,60.8 \t"
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M63.8,121c-0.6-0.6-1.1-0.9-1.7-0.9 s-0.9,0.2-1.3,0.7c-0.3,0.5-0.5,1.2-0.5,2c0,0.7,0.1,1.3,0.3,1.6c0.2,0.3,0.6,0.6,1,0.6c0.8,0.1,1.5-0.3,2.1-1.3V121z"
}), React.createElement("polygon", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  points: "53.8,40.9 51.7,40.9 51,43.7 53.1,43.7  "
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M36.1,49.2c0.2,0,0.5-0.1,0.7-0.2 c0.2-0.1,0.2-0.3,0.2-0.6c0-0.3-0.2-0.7-0.8-1l-0.3-0.2c-0.5,0.3-0.7,0.7-0.7,1.2c0,0.3,0.1,0.6,0.2,0.7 C35.5,49.1,35.9,49.2,36.1,49.2z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M36.1,46.5h0.2c0.5-0.2,0.7-0.6,0.7-0.9 c0-0.2-0.1-0.3-0.2-0.5c-0.1-0.1-0.3-0.2-0.6-0.2s-0.5,0.1-0.6,0.2c-0.1,0.1-0.2,0.2-0.2,0.5C35.4,45.9,35.6,46.2,36.1,46.5z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M57.1,98.3c-1.5,0-2.7,0.6-3.7,1.6 c-0.9,1.2-1.5,2.7-1.6,4.6h10V104C61.8,100.2,60.2,98.3,57.1,98.3z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M7.7,49.7c0.1,0,0.1,0,0.2,0.1 c0.2,0,0.6-0.1,1-0.2l-0.1-0.8c-0.2,0.1-0.3,0.1-0.5,0.1c0,0-0.1,0-0.1,0l-0.3,0.6L7.7,49.7z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M12,43.3V47c0,1,0.2,1.9,0.6,2.2 s1.1,0.6,2.2,0.6c0.7,0,1.3-0.1,1.9-0.2h0.1v-0.9c-0.5,0.1-1,0.2-1.6,0.2c-0.6,0-1-0.1-1.4-0.3c-0.2-0.1-0.2-0.2-0.3-0.5 c-0.1-0.2-0.1-0.5-0.1-0.9v-3.8h3.2v-1h-3.2v-1.6h-0.4l-1.1,2l-0.4,0.7H12z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M18,45.8v2.6c0,0.8,0.3,1.3,1,1.3 c0.6,0,0.9-0.3,1.3-0.8v0.7H21v-3.7h-0.7v2.4c-0.3,0.5-0.7,0.7-1,0.7c-0.2,0-0.3-0.1-0.5-0.2c-0.1-0.1-0.1-0.2-0.1-0.6v-2.3H18z"
}), React.createElement("rect", {
  x: 23.5,
  y: 44.2,
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  width: 0.8,
  height: 0.8
}), React.createElement("polygon", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  points: "22.1,46.4 23.5,46.4 23.5,49.5  23.5,49.6 24.1,49.6 24.1,45.9 22.1,45.9 \t"
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M26.4,45.8v3.7h0.7v-2.4c0.3-0.5,0.7-0.7,1-0.7 c0.2,0,0.3,0.1,0.5,0.2c0.1,0.1,0.1,0.3,0.1,0.6v2.3h0.7V47c0-0.8-0.3-1.3-1-1.3c-0.6,0-0.9,0.3-1.3,0.8v-0.7H26.4z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M31.3,45.1v0.8h-1v0.5h0.9v1.7 c0,0.6,0.1,0.9,0.3,1.2c0.2,0.2,0.6,0.3,1.1,0.3c0.2,0,0.6,0,0.9-0.1v-0.6c-0.2,0.1-0.6,0.1-0.8,0.1c-0.3,0-0.6,0-0.7-0.1 c0-0.1-0.1-0.1-0.1-0.2c0-0.1,0-0.2,0-0.5v-1.9h1.6v-0.5H32v-0.8H31.3z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M34.4,48.3c0,0.5,0.2,0.8,0.5,1 c0.3,0.2,0.7,0.3,1.1,0.3s0.8-0.2,1.1-0.5s0.5-0.6,0.5-1c0-0.3-0.1-0.6-0.2-0.8c-0.1-0.2-0.5-0.5-0.8-0.7c0.6-0.3,0.9-0.8,0.9-1.3 c0-0.3-0.1-0.6-0.3-0.8c-0.2-0.1-0.5-0.2-0.9-0.2s-0.8,0.1-1,0.3s-0.3,0.6-0.3,0.9c0,0.5,0.2,0.8,0.7,1.2 C35,47.2,34.6,47.7,34.4,48.3z M35.4,45.6c0-0.2,0.1-0.3,0.2-0.5c0.1-0.1,0.3-0.2,0.6-0.2s0.5,0.1,0.6,0.2c0.1,0.1,0.2,0.2,0.2,0.5 c0,0.3-0.2,0.7-0.7,0.9h-0.2C35.6,46.2,35.4,45.9,35.4,45.6z M35.9,47.1l0.3,0.2c0.6,0.3,0.8,0.7,0.8,1c0,0.2,0,0.5-0.2,0.6 c-0.2,0.1-0.5,0.2-0.7,0.2s-0.6-0.1-0.7-0.2c-0.1-0.1-0.2-0.3-0.2-0.7C35.2,47.8,35.4,47.4,35.9,47.1z"
}), React.createElement("rect", {
  x: 38.2,
  y: 49.5,
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  width: 4.1,
  height: 0.5
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M44.5,48.9c0-0.1-0.1-0.1-0.1-0.2 c0-0.1,0-0.2,0-0.5v-1.9h1.6v-0.5h-1.6v-0.8h-0.7v0.8h-0.9v0.5h0.9v1.7c0,0.5,0.1,0.9,0.3,1.1C44.1,49.1,44.3,49.1,44.5,48.9 C44.5,49,44.5,49,44.5,48.9z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M50.2,46.9l0.4-1.8h2.2l-0.3,1.1 c0.5-0.1,1.1-0.3,1.6-0.4l0.2-0.7h2.4l0.2-1.4h-2.4l0.7-2.8h2.3l0.3-1.3h-2.2l1-4.3h-1.5l-1,4.3H52l1-4.3h-1.6l-1,4.3H48L47.8,41 h2.4l-0.7,2.8h-2.3L47,45.2h2.2l-0.5,2.2C49.1,47.2,49.7,47.1,50.2,46.9z M51.7,40.9h2.2l-0.7,2.8H51L51.7,40.9z"
}), React.createElement("rect", {
  x: 63.3,
  y: 34.2,
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  width: 2.4,
  height: 2.4
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M65.5,44.2v-5.2h-5.6v1.4h3.7v3.9 C64.2,44.3,64.8,44.3,65.5,44.2z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M71.7,39.1v5.1c0.7,0,1.3,0,1.9,0.1v-1.4 c1-1.4,2.1-2.1,3-2.1c0.6,0,1,0.1,1.3,0.5c0.2,0.3,0.3,0.9,0.3,1.7v1.6c0.6,0.1,1.2,0.1,1.8,0.2v-2.4c0-2.3-1-3.5-3-3.5 c-1.5,0-2.6,0.7-3.5,2.2v-2H71.7z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M85.4,44.2c0-1.2,0.2-2.2,0.9-2.9 c0.6-0.7,1.5-1,2.6-1c0.8,0,1.8,0.2,3.1,0.7v-1.6c-1.1-0.3-2.2-0.5-3.3-0.5c-1.7,0-3.1,0.5-4,1.4c-1,1-1.5,2.3-1.5,4.1 c0,0.3,0,0.6,0.1,0.9c0.8,0.1,1.5,0.3,2.3,0.4C85.5,45.2,85.4,44.7,85.4,44.2z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M92.4,47.6c-1.1,0.5-2.2,0.7-3.1,0.7 c-0.5,0-0.9-0.1-1.3-0.2v1.6c0.3,0,0.6,0.1,0.9,0.1c1.1,0,2.2-0.2,3.3-0.6h0.2V47.6z"
}), React.createElement("polygon", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  points: "99,49.5 100.8,49.5 100.8,45.8 99,42.6  "
}), React.createElement("polygon", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  points: "95,35.7 95,35.7 95,35.7 95,35.7 \t"
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M1,61.3l-0.8,1.3c0.2,0.6,0.7,1,1.5,0.9 c0.2,0,0.6-0.1,1-0.2l-0.1-0.8c-0.2,0.1-0.3,0.1-0.5,0.1c-0.2,0-0.5-0.1-0.6-0.2c-0.1-0.1-0.1-0.5-0.1-0.9v-0.9L1,61.3z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M8.8,62.2c-0.5,0.2-0.9,0.3-1.5,0.3 c-0.8,0-1.7-0.2-2.9-0.7v1.3c1,0.3,1.9,0.6,2.9,0.5c1,0,1.9-0.2,2.5-0.7c0.6-0.5,0.9-1,0.9-1.9c0-0.6-0.1-0.9-0.5-1.3 c-0.2-0.3-0.7-0.6-1.4-0.8L7,58.2c-0.7-0.2-1-0.6-1-0.9s0.1-0.6,0.5-0.8c0.3-0.1,0.7-0.2,1.3-0.2c0.8,0,1.7,0.2,2.6,0.5v-1.2 c-1-0.2-1.9-0.3-2.6-0.3c-1,0-1.7,0.2-2.3,0.6c-0.6,0.5-0.8,1-0.8,1.7c0,1,0.7,1.7,1.8,2.1L8,60.1c0.9,0.3,1.4,0.7,1.4,1.2 C9.3,61.6,9.1,62,8.8,62.2z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M17.7,62.2c-0.5,0.2-0.9,0.3-1.5,0.3 c-0.8,0-1.7-0.2-2.9-0.7v1.3c1,0.3,2.1,0.6,2.9,0.5c1,0,1.9-0.2,2.5-0.7c0.6-0.5,0.9-1,0.9-1.9c0-0.6-0.1-0.9-0.5-1.3 c-0.2-0.3-0.7-0.6-1.4-0.8L16,58.2c-0.7-0.2-1-0.6-1-0.9s0.1-0.6,0.5-0.8c0.3-0.1,0.7-0.2,1.3-0.2c0.8,0,1.7,0.2,2.6,0.5v-1.2 c-1-0.2-1.9-0.3-2.6-0.3c-1,0-1.7,0.2-2.3,0.6c-0.6,0.5-0.8,1-0.8,1.7c0,1,0.7,1.7,1.8,2.1l1.5,0.5c0.9,0.3,1.4,0.7,1.4,1.2 C18.3,61.6,18,62,17.7,62.2z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M21.2,60.7l-0.1,0.7h1l-0.5,2.1h0.7l0.5-2.1h1 l-0.5,2.1h0.7l0.5-2.1h1.1l0.1-0.7h-1.1l0.3-1.3h1l0.1-0.7h-1l0.5-2h-0.7l-0.5,2h-1l0.5-2h-0.7l-0.5,2h-1.1l-0.1,0.7h1.1l-0.3,1.3 H21.2z M23.4,59.5h1l-0.3,1.3h-1L23.4,59.5z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M28,59.9c0.1-0.2,0.1-0.3,0.2-0.4 c0.2-0.3,0.5-0.4,0.8-0.5c0.2-0.2,0.5-0.4,0.7-0.6c-0.2-0.1-0.3-0.1-0.5-0.1c-0.6,0-1.1,0.3-1.5,0.8c-0.3,0.4-0.5,1-0.6,1.7 C27.4,60.6,27.7,60.3,28,59.9C28,60,28,60,28,59.9z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M31.3,56.3h-0.8v1.4c0.3-0.2,0.5-0.4,0.8-0.7 V56.3z"
}), React.createElement("polygon", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  points: "89.3,53.4 88,55.4 88,57.1 89.2,55.2  89.2,59.8 88,59.8 88,60.8 89.3,60.8 89.3,63.5 90.5,63.5 90.5,60.8 91.9,60.8 91.9,59.8 90.5,59.8 90.5,53.4 \t"
}), React.createElement("polygon", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  points: "92.9,57.9 95.2,63.5 96.3,63.5  98.6,57.9 97.6,57.9 95.8,62.3 94,57.9 \t"
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M102,57.8c-0.7,0-1.4,0.3-1.8,0.8 c-0.5,0.5-0.7,1.2-0.7,2.1c0,0.8,0.2,1.6,0.7,2.1c0.3,0.6,1,0.8,1.8,0.8s1.4-0.2,1.9-0.8c0.5-0.5,0.7-1.2,0.7-2.1 c0-0.8-0.2-1.6-0.7-2.1C103.5,58,102.8,57.8,102,57.8z M103.1,62.3c-0.3,0.3-0.7,0.6-1.1,0.6s-0.9-0.2-1.1-0.6 c-0.3-0.5-0.5-0.9-0.5-1.6s0.2-1.3,0.5-1.6c0.3-0.3,0.7-0.6,1.1-0.6s0.9,0.2,1.1,0.6c0.3,0.5,0.5,0.9,0.5,1.6S103.4,62,103.1,62.3z "
}), React.createElement("polygon", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  points: "106,57.9 106,58.7 107.9,58.7  107.9,63.5 109,63.5 109,59.8 107.9,57.9 \t"
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M-15.1,89.2c0.4,0.1,0.7,0.1,1.1,0.1 c1.9,0,3.5-0.8,4.8-2.4c1.3-1.6,1.8-3.7,1.8-6.4c0-1.4-0.2-2.6-0.6-3.7l-2.5,4.3c0,1.9-0.4,3.3-1,4.4c-0.6,1-1.5,1.6-2.5,1.7 l-1,1.7L-15.1,89.2z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M9.3,89V73H6.5v10.5c-1.5,2.1-3,3.1-4.5,3.1 c-0.9,0-1.6-0.3-1.9-0.8s-0.6-1.4-0.6-2.7V73h-2.9v10.9c0,3.6,1.5,5.5,4.5,5.5c2.3,0,4-1.2,5.4-3.4v3H9.3z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M17.3,65.7h-2.9v14.9c0.8-2.3,1.8-4.5,2.9-6.6 V65.7z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M56.1,75.2V89H59V73h-0.4 c-1.1,0.6-2.2,1.4-3.3,2.2H56.1z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M68.1,81c0,2.7,0.7,4.6,2.2,6.2 c1.5,1.5,3.7,2.2,6.4,2.2c1.6,0,3.3-0.3,5-0.9h0.1v-2.3c-1.7,0.7-3.3,1-4.7,1c-1.8,0-3.3-0.6-4.3-1.6c-1-1-1.6-2.6-1.6-4.5 c0-2,0.6-3.5,1.5-4.5c0.9-1,2.3-1.6,4-1.6c1.4,0,3,0.3,4.8,1v-2.4c-1.7-0.6-3.3-0.8-5-0.8c-2.6,0-4.7,0.7-6.2,2.2 C68.8,76.4,68.1,78.4,68.1,81z"
}), React.createElement("polygon", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  points: "90.8,82.4 84.3,85.8 90.8,89 90.8,88.1  86.3,85.8 90.8,83.5 \t"
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M97,88.7c0.6-0.3,0.8-0.8,0.8-1.5 c0-0.5-0.1-0.8-0.3-1c-0.2-0.2-0.6-0.5-1.1-0.7l-1.5-0.6c-0.6-0.2-0.9-0.5-0.9-0.8s0.1-0.6,0.3-0.7s0.6-0.2,1-0.2 c0.7,0,1.4,0.1,2.2,0.3v-1c-0.8-0.2-1.6-0.3-2.2-0.3c-0.8,0-1.5,0.1-1.9,0.5c-0.5,0.3-0.7,0.8-0.7,1.4c0,0.8,0.5,1.4,1.5,1.7 l1.3,0.5c0.8,0.2,1.1,0.6,1.1,0.9s-0.1,0.6-0.5,0.8c-0.3,0.2-0.8,0.3-1.3,0.3c-0.7,0-1.5-0.1-2.4-0.6v1.2c0.9,0.2,1.7,0.3,2.5,0.5 C95.7,89.3,96.4,89,97,88.7z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M101.9,88.6c0.3,0.3,1,0.6,2.1,0.6 c0.6,0,1.1,0,1.7-0.1h0.1v-1.2c-0.5,0.1-1,0.2-1.5,0.2c-0.6,0-1,0-1.3-0.2c-0.2-0.1-0.3-0.2-0.3-0.3c-0.1-0.1-0.1-0.5-0.1-0.8v-3.5 h3v-0.9h-3v-1.5h-1.3v1.5h-1.7v0.9h1.7v3.3C101.3,87.5,101.5,88.2,101.9,88.6z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M113.1,79.6c-0.3,0.2-0.8,0.4-1.3,0.4v3 c-0.5-0.6-1.1-0.9-1.8-0.9c-0.9,0-1.5,0.3-2.1,1c-0.6,0.7-0.8,1.5-0.8,2.7c0,1,0.2,1.9,0.7,2.4c0.5,0.6,1,0.9,1.8,0.9 c0.8,0,1.6-0.5,2.2-1.4V89h1.3V79.6z M111.7,83.9v2.9c-0.6,0.8-1.3,1.3-1.9,1.3c-0.9,0-1.4-0.8-1.4-2.4c0-0.8,0.1-1.5,0.5-2 s0.7-0.7,1.3-0.7c0.6,0,1.1,0.3,1.7,0.9H111.7z"
}), React.createElement("polygon", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  points: "118.8,89 118.8,82.3 115.1,82.3  115.1,83.2 117.5,83.2 117.5,89 \t"
}), React.createElement("rect", {
  x: 117.3,
  y: 79.2,
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  width: 1.5,
  height: 1.5
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M122.8,83.7c-0.3,0.5-0.4,1.2-0.4,2 c0,1,0.2,2,0.8,2.6c0.6,0.6,1.3,0.9,2.3,0.9c0.2,0,0.3,0,0.5,0l-0.2-0.3l-0.4-0.6c-0.5,0-1-0.2-1.3-0.7c-0.3-0.5-0.5-1.2-0.5-2 c0-0.1,0-0.2,0-0.4L122.8,83.7z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M-17.7,97.5v-1c-0.5-0.2-1-0.3-1.5-0.3l-0.6,1 C-19.1,97.2-18.4,97.3-17.7,97.5z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M-20.3,103.1c0.8,0,1.5-0.2,2.1-0.6 s0.8-0.8,0.8-1.5c0-0.5-0.1-0.8-0.3-1s-0.6-0.5-1.1-0.7l-1.5-0.6c-0.1,0-0.1-0.1-0.2-0.1l-0.3,0.5l-0.2,0.4c0.1,0,0.1,0,0.1,0.1 l1.3,0.5c0.8,0.2,1.1,0.6,1.1,0.9s-0.1,0.6-0.5,0.8c-0.3,0.2-0.8,0.3-1.3,0.3c-0.3,0-0.7,0-1-0.1l0.3,0.6l0.3,0.4 C-20.6,103.1-20.4,103.1-20.3,103.1z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M-9.4,103h0.1v-1.2c-0.5,0.1-1,0.2-1.5,0.2 c-0.6,0-1,0-1.3-0.2c-0.2-0.1-0.3-0.2-0.3-0.3c-0.1-0.1-0.1-0.5-0.1-0.8v-3.5h3v-0.9h-3v-1.5h-1.3v1.5h-1.7v0.9h1.7v3.3 c0,1,0.2,1.7,0.6,2.1s1,0.6,2.1,0.6C-10.6,103.1-10,103.1-9.4,103z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M-1.4,101.7c-0.1,0.1-0.2,0.1-0.3,0.1 c-0.2,0-0.3-0.1-0.5-0.2c-0.1-0.1-0.1-0.3-0.1-0.8V98c0-0.8-0.2-1.4-0.6-1.7s-1-0.5-1.8-0.5c-0.7,0-1.5,0.1-2.4,0.5v1 c0.8-0.3,1.5-0.6,2.2-0.6c0.5,0,0.8,0.1,1,0.3c0.2,0.2,0.3,0.6,0.3,1v0.6h-0.8c-1,0-1.8,0.2-2.4,0.7c-0.6,0.5-0.9,1-0.9,1.7 c0,0.6,0.2,1,0.6,1.4c0.3,0.3,0.9,0.6,1.5,0.6c0.7,0,1.5-0.3,2.2-0.9c0.1,0.6,0.6,0.9,1.3,0.5c0.2,0,0.5-0.1,0.9-0.2L-1.4,101.7z M-3.7,101.4c-0.6,0.5-1.1,0.7-1.7,0.8c-0.3,0-0.6-0.1-0.8-0.3c-0.2-0.2-0.3-0.5-0.3-0.8c0-0.9,0.8-1.4,2.5-1.4h0.3V101.4z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M5.8,101.8c-0.5,0.1-1,0.2-1.5,0.2 c-0.6,0-1,0-1.3-0.2c-0.2-0.1-0.3-0.2-0.3-0.3c-0.1-0.1-0.1-0.5-0.1-0.8v-3.5h3v-0.9h-3v-1.5H1.3v1.5h-1.7v0.9h1.7v3.3 c0,1,0.2,1.7,0.6,2.1s1,0.6,2.1,0.6c0.6,0,1.1,0,1.7-0.1h0.1V101.8z"
}), React.createElement("rect", {
  x: 9.8,
  y: 93.1,
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  width: 1.5,
  height: 1.5
}), React.createElement("polygon", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  points: "11.3,103 11.3,96.3 7.6,96.3 7.6,97.2  10,97.2 10,103 \t"
}), React.createElement("rect", {
  x: -12.9,
  y: 107.1,
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  width: 1.5,
  height: 1.5
}), React.createElement("polygon", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  points: "-11.5,116.9 -11.5,110.2 -15.1,110.2  -15.1,111.1 -12.7,111.1 -12.7,116.9 \t"
}), React.createElement("polygon", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  points: "-7.8,116.9 -1.9,116.9 -1.9,116  -6.4,116 -2.1,111.1 -2.1,110.2 -7.7,110.2 -7.7,111.1 -3.5,111.1 -7.8,116 \t"
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M5.8,113.6c0-1.3-0.2-2.1-0.7-2.7 c-0.5-0.6-1.1-0.8-2.1-0.8c-0.9,0-1.7,0.3-2.3,1c-0.6,0.6-0.9,1.5-0.9,2.6s0.3,2,0.9,2.6c0.6,0.6,1.5,0.9,2.6,0.9 c0.7,0,1.5-0.2,2.3-0.5h0.1v-0.9c-0.8,0.3-1.5,0.5-2.2,0.5c-1.5,0-2.3-0.8-2.4-2.3h4.6V113.6z M4.3,113H1.1 c0.1-0.7,0.2-1.2,0.6-1.5c0.2-0.3,0.7-0.6,1.1-0.6c1,0,1.5,0.6,1.5,1.9V113z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M10.3,117.1c1,0,1.8-0.2,2.3-0.9 c0.2-0.2,0.3-0.3,0.4-0.6c-0.4-1.6-0.6-3.3-0.9-5c-0.5-0.3-1-0.5-1.8-0.5c-0.9,0-1.7,0.3-2.3,0.9c-0.6,0.6-0.8,1.5-0.8,2.6 s0.2,2,0.8,2.6C8.5,116.7,9.2,117.1,10.3,117.1z M8.9,111.5c0.3-0.5,0.8-0.7,1.4-0.7c0.6,0,1,0.2,1.4,0.7s0.5,1.2,0.5,2 s-0.1,1.5-0.5,2c-0.3,0.5-0.8,0.7-1.4,0.7c-0.6,0-1-0.2-1.4-0.7c-0.3-0.5-0.5-1.2-0.5-2C8.4,112.5,8.5,111.9,8.9,111.5z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M66,106.3c0-3.7-0.7-6.4-2.1-8.1 c-1.4-1.7-3.4-2.6-6.3-2.6c-2.9,0-5.1,1-7,3.1c-1.8,2.1-2.7,4.8-2.7,8c0,3.4,0.9,6,2.9,7.9c0.9,0.9,2,1.6,3.3,2.1v-0.4h1.5v0.8 c1,0.2,2.1,0.3,3.3,0.3c2.2,0,4.5-0.3,7.1-1.3V113c-2.4,1-4.6,1.5-6.6,1.5c-4.8,0-7.3-2.3-7.5-7.1H66V106.3z M61.8,104.6h-10 c0.1-2,0.7-3.5,1.6-4.6c0.9-1,2.2-1.6,3.7-1.6c3.1,0,4.7,1.9,4.7,5.7V104.6z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M87.7,116.2v1c0.6-0.1,1.1-0.1,1.7-0.3h0.2v-3 c-1.6,0.3-3.1,0.6-4.7,0.6c-1.6,0-2.9-0.2-3.8-0.8c-0.5-0.3-0.8-0.7-0.9-1.2s-0.2-1.3-0.2-2.4V99.4h9.2v-2.9H80V92h-3.8v4.5h-5.1 v2.9h5.1v10.1c0,3,0.5,5.1,1.6,6.3c1,1,3.1,1.6,6.2,1.6c0.8,0,1.6,0,2.4-0.1v-1.1H87.7z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M111.9,116.9V96H108v13.6 c-1.9,2.8-4,4.2-5.8,4.2c-1.1,0-2.1-0.3-2.5-1s-0.7-1.9-0.7-3.5V96h-3.8v14.3c0,4.8,1.9,7.1,5.8,7.1c3,0,5.4-1.5,7.1-4.4v4H111.9z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M125,103.3c1.3-1.6,2.4-2.8,3.4-3.5 c1-0.6,1.9-0.9,3.1-1l-1.6-2.8c-1.9,0.6-3.5,2-4.9,4v-4h-3.8v20.9h2.3l0.9-1.6l0.5-0.8V103.3z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M-8.4,121.8v-2.1c-1-0.3-2-0.5-3.1-0.5l1.2,2.1 C-9.6,121.4-9,121.6-8.4,121.8z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M-2.9,129c0.7-0.9,1.6-1.4,2.9-1.4 c1.3,0,2.2,0.5,2.9,1.4c0.7,1,1,2.3,1,4.1s-0.3,3.1-1,4.1c-0.7,0.9-1.6,1.4-2.9,1.4c-0.1,0-0.1,0-0.2,0l1.1,1.9 c1.6-0.2,2.9-0.8,3.9-1.9c1.1-1.4,1.7-3.1,1.7-5.5c0-2.3-0.6-4.2-1.7-5.5c-1.1-1.3-2.7-2-4.8-2s-3.7,0.7-4.8,2 c-0.4,0.4-0.6,0.9-0.9,1.4l1.7,3l0.1,0.2C-3.8,130.9-3.5,129.8-2.9,129z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M14.4,131c0.8-1,1.6-1.9,2.3-2.3 c0.2-0.1,0.5-0.3,0.7-0.4c-0.3-0.6-0.6-1.2-0.9-1.8c-0.8,0.5-1.5,1.2-2.1,2.2V126h-2.5v14.2h2.5V131z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M25.4,140.1c-0.2-0.2-0.4-0.4-0.6-0.7v0.5 C25,140,25.2,140.1,25.4,140.1z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M70.2,131.4c-1.1,0-1.9,0.2-2.5,0.7 c-0.1,0.1-0.2,0.2-0.3,0.3c0.7,0.1,1.3,0.2,2,0.3c0.2-0.1,0.5-0.1,0.8-0.1c0.6,0,1.3,0.1,2.1,0.3c0.2,0,0.4,0,0.6,0 c0,0,0.1,0,0.1,0v-1.1C71.9,131.5,71,131.4,70.2,131.4z"
}), React.createElement("rect", {
  x: 79,
  y: 127.6,
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  width: 1.9,
  height: 2
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M76.1,131.6v1.1c1.5-0.1,3-0.3,4.6-0.6v-0.5 H76.1z"
}), React.createElement("rect", {
  x: 88,
  y: 139,
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  width: 5,
  height: 1.2
}), React.createElement("polygon", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  points: "92.8,131.6 88,131.6 88,132.8 91,132.8  88,136.2 88,138.2 92.8,132.8 \t"
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M102.7,135.9c0-1.5-0.2-2.7-0.8-3.4 s-1.5-1-2.6-1s-2.1,0.5-2.9,1.3c-0.8,0.8-1.1,1.9-1.1,3.3s0.3,2.4,1.1,3.3c0.7,0.8,1.8,1.2,3.3,1.2c0.9,0,1.9-0.2,3-0.6v-1.3 c-1,0.3-1.9,0.6-2.7,0.6c-1.9,0-3-0.9-3.1-2.9h5.8V135.9z M101,135.1h-4.1c0.1-0.8,0.3-1.4,0.7-1.9c0.3-0.5,0.9-0.7,1.5-0.7 c1.3,0,1.9,0.8,1.9,2.3V135.1z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M112.5,136C112.5,136,112.5,136,112.5,136 c0-1.4-0.3-2.5-1-3.3c-0.8-0.8-1.7-1.2-3-1.2c-1.3,0-2.3,0.3-3,1.2c-0.7,0.8-1,1.9-1,3.3s0.3,2.4,1,3.3c0.8,0.8,1.7,1.2,3,1.2 c0.6,0,1.2-0.1,1.7-0.3l0.7-1.2L112.5,136z M108.5,139.3c-0.7,0-1.4-0.3-1.7-0.9c-0.3-0.6-0.6-1.4-0.6-2.4s0.2-1.9,0.6-2.4 c0.3-0.6,1-0.9,1.7-0.9c0.7,0,1.4,0.3,1.7,0.9c0.3,0.6,0.6,1.4,0.6,2.4s-0.2,1.9-0.6,2.4C109.9,138.9,109.2,139.3,108.5,139.3z"
}), React.createElement("polygon", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  points: "114.6,131.8 114.6,132.5 114.9,131.8 \t "
}), React.createElement("polygon", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  points: "17.8,151.7 13.8,161.1 10,151.7  7.8,151.7 9.1,154.8 14.1,163.4 14.7,163.4 19.6,151.7 \t"
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M26.8,163.7c1.7,0,3-0.5,4-1.6 c1-1.2,1.5-2.7,1.5-4.5c0-2-0.6-3.5-1.5-4.5c-1-1-2.3-1.6-4-1.6s-3.1,0.6-4,1.6c-1,1.2-1.5,2.7-1.5,4.5c0,2,0.6,3.5,1.5,4.5 C23.9,163.1,25.1,163.7,26.8,163.7z M24.4,154.3c0.6-0.8,1.4-1.2,2.4-1.2s1.8,0.3,2.4,1.2c0.6,0.8,0.8,2,0.8,3.4 c0,1.5-0.2,2.6-0.8,3.4c-0.6,0.8-1.4,1.2-2.4,1.2s-1.8-0.5-2.4-1.2c-0.6-0.8-0.8-2-0.8-3.4C23.6,156.1,23.9,155.1,24.4,154.3z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M41.7,152.5c-0.7-0.3-1.4-0.7-2.1-1.1v11.9h2.1 V152.5z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M52.4,156.5c-1.1,0.2-2.1,0.5-2.9,1.1 c-1,0.7-1.6,1.7-1.6,2.9c0,0.9,0.3,1.7,1,2.3c0.7,0.6,1.6,0.9,2.6,0.9c1.3,0,2.5-0.6,3.8-1.6c0.3,1,1,1.6,2.1,1.4 c0.3,0,0.9-0.1,1.6-0.3l-0.2-1.3c-0.3,0.1-0.6,0.1-0.7,0.1c-0.3,0-0.7-0.1-0.8-0.3s-0.2-0.7-0.2-1.4v-2.7 C55.4,157.2,53.9,156.9,52.4,156.5z M55,160.6c-1,0.8-1.9,1.3-2.9,1.3c-0.7,0-1.1-0.1-1.5-0.5c-0.3-0.3-0.6-0.8-0.6-1.4 c0-1.5,1.5-2.3,4.3-2.3H55V160.6z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M68.1,163.7c1,0,2.1,0,3.1-0.2v-1.6 c-0.9,0.2-1.7,0.3-2.6,0.3c-0.9,0-1.6-0.1-2.1-0.5c-0.3-0.2-0.5-0.5-0.6-0.7c-0.1-0.2-0.1-0.7-0.1-1.4v-1.1c-0.7,0-1.4-0.1-2.1-0.1 v0.8c0,1.7,0.3,2.9,0.9,3.5C65.3,163.3,66.4,163.7,68.1,163.7z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M80.7,157.8c-0.7,0.1-1.4,0.2-2.1,0.3v5.3h2.1 V157.8z"
}), React.createElement("polygon", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  points: "94.1,163.3 94.1,146.3 88,146.3 88,148  92,148 92,163.3 \t"
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M101.9,153.2c-0.9,1-1.3,2.2-1.4,3.7l2.8-4.8 C102.7,152.4,102.3,152.7,101.9,153.2z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M92.8,69.8V77h1.4v-4.8c0.3-0.5,0.7-0.9,1.1-1.2 c0.5-0.2,0.9-0.3,1.4-0.3c0.2,0,0.3,0.1,0.6,0.1v1h1v-2.1c-0.6-0.1-1-0.1-1.4-0.1c-1.1,0-2.1,0.5-2.7,1.5v-1.4H92.8z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M106.3,73.6c0-1.4-0.2-2.3-0.7-2.9 c-0.5-0.6-1.1-0.9-2.2-0.9c-1,0-1.9,0.5-2.5,1.2c-0.6,0.7-0.9,1.6-0.9,2.8c0,1.2,0.3,2.2,1,2.8c0.7,0.6,1.6,0.9,2.9,0.9 c0.8,0,1.6-0.1,2.5-0.5h-0.1v-0.8c-0.8,0.3-1.6,0.5-2.3,0.5c-1.6,0-2.5-0.9-2.6-2.6h4.9V73.6z M105.1,72.9h-3.5 c0-0.7,0.3-1.3,0.7-1.6s0.7-0.6,1.3-0.6c1,0,1.6,0.7,1.6,2V72.9z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M113.7,79.2c0.3-0.3,0.6-0.7,0.7-1.3 c0.1-0.6,0.2-1.3,0.2-2.2v-5.9h-1.3v0.8c-0.7-0.7-1.4-1-2.1-1c-0.9,0-1.6,0.3-2.2,1.2c-0.6,0.8-0.8,1.7-0.8,2.9 c0,1,0.2,1.9,0.7,2.6c0.5,0.6,1.1,0.9,1.9,0.9c1,0,1.8-0.5,2.4-1.5l-0.1,1.3c0,1.4-0.8,2.1-2.2,2.1c-0.7,0-1.4-0.1-2.2-0.5 l-0.1,1.2c0.9,0.3,1.7,0.5,2.3,0.5c0.3,0,0.6,0,0.8-0.1c0.5-0.1,0.9-0.2,1.3-0.4C113.3,79.5,113.5,79.3,113.7,79.2z M111.3,76.1 c-0.5,0-0.8-0.2-1.1-0.7c-0.3-0.5-0.5-1-0.5-1.9s0.1-1.5,0.5-2.1s0.8-0.8,1.4-0.8s1.3,0.3,1.8,1v2.9 C112.6,75.6,111.9,76,111.3,76.1z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M49.4,120.5v-1c-0.4-0.1-0.8-0.2-1.2-0.3 c0.2,0.4,0.5,0.8,0.7,1.2C49.1,120.5,49.2,120.5,49.4,120.5z"
}), React.createElement("polygon", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  points: "55.5,126.1 55.5,119.4 51.9,119.4  51.9,120.3 54.3,120.3 54.3,126.1 \t"
}), React.createElement("polygon", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  points: "54.1,116.2 54.1,116.7 54.1,117.8  55.5,117.8 55.5,117.1 55.5,116.2 \t"
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M61.8,127.9c-0.7,0-1.4-0.1-2.1-0.5l-0.1,1 c0.8,0.2,1.5,0.3,2.1,0.2c1.1,0,1.9-0.2,2.4-0.8c0.3-0.3,0.6-0.7,0.7-1.2s0.2-1,0.2-2v-5.5h-1.1v0.8c-0.7-0.6-1.3-0.9-1.9-0.9 c-0.9,0-1.5,0.3-2.1,1s-0.8,1.6-0.8,2.7c0,0.9,0.2,1.7,0.7,2.3c0.5,0.6,1,0.9,1.8,0.9c0.9,0,1.7-0.5,2.2-1.4v1.3 C63.8,127.3,63.1,127.9,61.8,127.9z M61.7,125c-0.5,0-0.8-0.2-1-0.6c-0.2-0.3-0.3-0.9-0.3-1.6c0-0.8,0.1-1.5,0.5-2 c0.3-0.5,0.7-0.7,1.3-0.7s1.1,0.3,1.7,0.9v2.7C63.2,124.6,62.5,125.1,61.7,125z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M72.5,126.2v-4.6c0-1.5-0.7-2.3-1.9-2.3 c-1,0-1.7,0.5-2.3,1.4v-1.3H67v6.7h1.3v-4.4c0.7-0.8,1.4-1.3,1.9-1.3c0.3,0,0.7,0.1,0.8,0.3s0.2,0.6,0.2,1.2v4.3H72.5z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M80.4,122.8c0-1.3-0.2-2.1-0.7-2.7 c-0.5-0.6-1.1-0.8-2.1-0.8c-0.9,0-1.7,0.3-2.3,1c-0.6,0.6-0.9,1.5-0.9,2.6s0.3,2,0.9,2.6c0.6,0.6,1.5,0.9,2.6,0.9 c0.7,0,1.5-0.2,2.3-0.5h0.1V125c-0.8,0.3-1.5,0.5-2.2,0.5c-1.5,0-2.3-0.8-2.4-2.3h4.6V122.8z M78.9,122.2h-3.2 c0.1-0.7,0.2-1.2,0.6-1.5c0.2-0.3,0.7-0.6,1.1-0.6c1,0,1.5,0.6,1.5,1.9V122.2z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M87.7,126.1v-8.9v-1h-1.3v1.1v2.8 c-0.5-0.6-1.1-0.9-1.8-0.9c-0.9,0-1.5,0.3-2.1,1s-0.8,1.5-0.8,2.7c0,1,0.2,1.9,0.7,2.4s1,0.9,1.8,0.9s1.6-0.5,2.2-1.4v1.3H87.7z M86.3,121v2.9c-0.6,0.8-1.3,1.3-1.9,1.3c-0.9,0-1.4-0.8-1.4-2.4c0-0.8,0.1-1.5,0.5-2c0.3-0.5,0.7-0.7,1.3-0.7s1.1,0.3,1.7,0.9 H86.3z"
})), React.createElement("path", {
  id: "XMLID_4_",
  display: "none",
  fill: "none",
  stroke: "#ED1F2F",
  strokeWidth: 3,
  strokeMiterlimit: 10,
  d: "M94,33.9H16.7 l-38.7,67l38.7,67H94l38.7-67L94,33.9z"
}), React.createElement("path", {
  id: "XMLID_1_",
  fill: "none",
  stroke: "#231F20",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  d: "M94,34H16.7L-22,101l38.7,67H94 l38.7-67L94,34z M87.9,72.2c-5.8-1.6-11.3-2.4-16.5-2.4c-7.9,0-14.5,2.9-19.7,8.8c-5.2,5.9-7.8,13.3-7.8,22.4 c0,9.8,2.6,17.5,7.9,23.2c5.2,5.8,12.2,8.6,21,8.6c4.3,0,9.3-0.8,15.1-2.4v25.8c-6.4,1.7-12.2,2.5-17.3,2.5 c-17.6,0-31.9-5.4-42.9-16.1c-11-10.7-16.4-24.9-16.4-42.4c0-16.3,5.5-29.7,16.6-40.2c11.1-10.6,25-15.9,41.9-15.9 c6.6,0,12.6,0.7,18.1,2.1V72.2z"
})), React.createElement("symbol", {
  id: "icon-MCU",
  viewBox: "0 0 204 202",
  xmlSpace: "preserve"
}, React.createElement("g", {
  id: "Layer_2"
}, React.createElement("path", {
  id: "XMLID_1_",
  fill: "#12723A",
  stroke: "#FFFFFF",
  strokeWidth: 6,
  strokeMiterlimit: 10,
  d: "M177,202H27 c-13.8,0-25-11.3-25-25V27C2,13.3,13.3,2,27,2h150c13.8,0,25,11.3,25,25v150C202,190.8,190.8,202,177,202z"
}), React.createElement("path", {
  id: "XMLID_2_",
  stroke: "#565656",
  strokeMiterlimit: 10,
  d: "M150,162H54c-6.6,0-12-5.4-12-12V54c0-6.6,5.4-12,12-12h96 c6.6,0,12,5.4,12,12v96C162,156.6,156.6,162,150,162z"
})), React.createElement("g", {
  id: "Layer_1"
}, React.createElement("g", {
  id: "XMLID_13_"
}, React.createElement("line", {
  id: "XMLID_3_",
  fill: "none",
  stroke: "#2D2D2D",
  strokeWidth: 9,
  strokeMiterlimit: 10,
  x1: 142,
  y1: 24.1,
  x2: 142,
  y2: 41.8
}), React.createElement("line", {
  id: "XMLID_4_",
  fill: "none",
  stroke: "#2D2D2D",
  strokeWidth: 9,
  strokeMiterlimit: 10,
  x1: 82,
  y1: 24.1,
  x2: 82,
  y2: 41.8
}), React.createElement("line", {
  id: "XMLID_5_",
  fill: "none",
  stroke: "#2D2D2D",
  strokeWidth: 9,
  strokeMiterlimit: 10,
  x1: 62,
  y1: 24.1,
  x2: 62,
  y2: 41.8
}), React.createElement("line", {
  id: "XMLID_8_",
  fill: "none",
  stroke: "#2D2D2D",
  strokeWidth: 9,
  strokeMiterlimit: 10,
  x1: 102,
  y1: 24.1,
  x2: 102,
  y2: 41.8
}), React.createElement("line", {
  id: "XMLID_6_",
  fill: "none",
  stroke: "#2D2D2D",
  strokeWidth: 9,
  strokeMiterlimit: 10,
  x1: 122,
  y1: 24.1,
  x2: 122,
  y2: 41.8
}), React.createElement("circle", {
  id: "XMLID_7_",
  fill: "#2D2D2D",
  cx: 62,
  cy: 24.1,
  r: 7.4
}), React.createElement("circle", {
  id: "XMLID_9_",
  fill: "#2D2D2D",
  cx: 82,
  cy: 24.1,
  r: 7.4
}), React.createElement("circle", {
  id: "XMLID_10_",
  fill: "#2D2D2D",
  cx: 102,
  cy: 24.1,
  r: 7.4
}), React.createElement("circle", {
  id: "XMLID_11_",
  fill: "#2D2D2D",
  cx: 122,
  cy: 24.1,
  r: 7.4
}), React.createElement("circle", {
  id: "XMLID_12_",
  fill: "#2D2D2D",
  cx: 142,
  cy: 24.1,
  r: 7.4
})), React.createElement("g", {
  id: "XMLID_14_"
}, React.createElement("line", {
  id: "XMLID_24_",
  fill: "none",
  stroke: "#2D2D2D",
  strokeWidth: 9,
  strokeMiterlimit: 10,
  x1: 24.3,
  y1: 62.3,
  x2: 42,
  y2: 62.3
}), React.createElement("line", {
  id: "XMLID_23_",
  fill: "none",
  stroke: "#2D2D2D",
  strokeWidth: 9,
  strokeMiterlimit: 10,
  x1: 24.3,
  y1: 122.3,
  x2: 42,
  y2: 122.3
}), React.createElement("line", {
  id: "XMLID_22_",
  fill: "none",
  stroke: "#2D2D2D",
  strokeWidth: 9,
  strokeMiterlimit: 10,
  x1: 24.3,
  y1: 142.3,
  x2: 42,
  y2: 142.3
}), React.createElement("line", {
  id: "XMLID_21_",
  fill: "none",
  stroke: "#2D2D2D",
  strokeWidth: 9,
  strokeMiterlimit: 10,
  x1: 24.3,
  y1: 102.3,
  x2: 42,
  y2: 102.3
}), React.createElement("line", {
  id: "XMLID_20_",
  fill: "none",
  stroke: "#2D2D2D",
  strokeWidth: 9,
  strokeMiterlimit: 10,
  x1: 24.3,
  y1: 82.3,
  x2: 42,
  y2: 82.3
}), React.createElement("circle", {
  id: "XMLID_19_",
  fill: "#2D2D2D",
  cx: 24.3,
  cy: 142.3,
  r: 7.4
}), React.createElement("circle", {
  id: "XMLID_18_",
  fill: "#2D2D2D",
  cx: 24.3,
  cy: 122.3,
  r: 7.4
}), React.createElement("circle", {
  id: "XMLID_17_",
  fill: "#2D2D2D",
  cx: 24.3,
  cy: 102.3,
  r: 7.4
}), React.createElement("circle", {
  id: "XMLID_16_",
  fill: "#2D2D2D",
  cx: 24.3,
  cy: 82.3,
  r: 7.4
}), React.createElement("circle", {
  id: "XMLID_15_",
  fill: "#2D2D2D",
  cx: 24.3,
  cy: 62.3,
  r: 7.4
})), React.createElement("g", {
  id: "XMLID_25_"
}, React.createElement("line", {
  id: "XMLID_35_",
  fill: "none",
  stroke: "#2D2D2D",
  strokeWidth: 9,
  strokeMiterlimit: 10,
  x1: 62,
  y1: 179.7,
  x2: 62,
  y2: 162
}), React.createElement("line", {
  id: "XMLID_34_",
  fill: "none",
  stroke: "#2D2D2D",
  strokeWidth: 9,
  strokeMiterlimit: 10,
  x1: 122,
  y1: 179.7,
  x2: 122,
  y2: 162
}), React.createElement("line", {
  id: "XMLID_33_",
  fill: "none",
  stroke: "#2D2D2D",
  strokeWidth: 9,
  strokeMiterlimit: 10,
  x1: 142,
  y1: 179.7,
  x2: 142,
  y2: 162
}), React.createElement("line", {
  id: "XMLID_32_",
  fill: "none",
  stroke: "#2D2D2D",
  strokeWidth: 9,
  strokeMiterlimit: 10,
  x1: 102,
  y1: 179.7,
  x2: 102,
  y2: 162
}), React.createElement("line", {
  id: "XMLID_31_",
  fill: "none",
  stroke: "#2D2D2D",
  strokeWidth: 9,
  strokeMiterlimit: 10,
  x1: 82,
  y1: 179.7,
  x2: 82,
  y2: 162
}), React.createElement("circle", {
  id: "XMLID_30_",
  fill: "#2D2D2D",
  cx: 142,
  cy: 179.7,
  r: 7.4
}), React.createElement("circle", {
  id: "XMLID_29_",
  fill: "#2D2D2D",
  cx: 122,
  cy: 179.7,
  r: 7.4
}), React.createElement("circle", {
  id: "XMLID_28_",
  fill: "#2D2D2D",
  cx: 102,
  cy: 179.7,
  r: 7.4
}), React.createElement("circle", {
  id: "XMLID_27_",
  fill: "#2D2D2D",
  cx: 82,
  cy: 179.7,
  r: 7.4
}), React.createElement("circle", {
  id: "XMLID_26_",
  fill: "#2D2D2D",
  cx: 62,
  cy: 179.7,
  r: 7.4
})), React.createElement("g", {
  id: "XMLID_36_"
}, React.createElement("line", {
  id: "XMLID_46_",
  fill: "none",
  stroke: "#2D2D2D",
  strokeWidth: 9,
  strokeMiterlimit: 10,
  x1: 179.7,
  y1: 142.3,
  x2: 162,
  y2: 142.3
}), React.createElement("line", {
  id: "XMLID_45_",
  fill: "none",
  stroke: "#2D2D2D",
  strokeWidth: 9,
  strokeMiterlimit: 10,
  x1: 179.7,
  y1: 82.3,
  x2: 162,
  y2: 82.3
}), React.createElement("line", {
  id: "XMLID_44_",
  fill: "none",
  stroke: "#2D2D2D",
  strokeWidth: 9,
  strokeMiterlimit: 10,
  x1: 179.7,
  y1: 62.3,
  x2: 162,
  y2: 62.3
}), React.createElement("line", {
  id: "XMLID_43_",
  fill: "none",
  stroke: "#2D2D2D",
  strokeWidth: 9,
  strokeMiterlimit: 10,
  x1: 179.7,
  y1: 102.3,
  x2: 162,
  y2: 102.3
}), React.createElement("line", {
  id: "XMLID_42_",
  fill: "none",
  stroke: "#2D2D2D",
  strokeWidth: 9,
  strokeMiterlimit: 10,
  x1: 179.7,
  y1: 122.3,
  x2: 162,
  y2: 122.3
}), React.createElement("circle", {
  id: "XMLID_41_",
  fill: "#2D2D2D",
  cx: 179.7,
  cy: 62.3,
  r: 7.4
}), React.createElement("circle", {
  id: "XMLID_40_",
  fill: "#2D2D2D",
  cx: 179.7,
  cy: 82.3,
  r: 7.4
}), React.createElement("circle", {
  id: "XMLID_39_",
  fill: "#2D2D2D",
  cx: 179.7,
  cy: 102.3,
  r: 7.4
}), React.createElement("circle", {
  id: "XMLID_38_",
  fill: "#2D2D2D",
  cx: 179.7,
  cy: 122.3,
  r: 7.4
}), React.createElement("circle", {
  id: "XMLID_37_",
  fill: "#2D2D2D",
  cx: 179.7,
  cy: 142.3,
  r: 7.4
})), React.createElement("g", {
  id: "XMLID_88_"
}, React.createElement("path", {
  id: "XMLID_89_",
  fill: "#FFFFFF",
  d: "M64.3,120.6l-7-21.4L56,94.4l-0.5,4.9l-2.3,20.8c-0.1,0.7-0.7,1.3-1.5,1.3h-4 c-0.7,0-1.3-0.5-1.2-1.3L51,85c0.1-1,0.8-1.6,1.8-1.6h4.8c0.7,0,1.4,0.5,1.6,1.2l7.9,24.4l1.1,3.7l1.1-3.6l8-24.5 c0.2-0.7,0.9-1.2,1.6-1.2h4.4c1,0,1.7,0.6,1.8,1.6l4.4,35.1c0.1,0.8-0.4,1.3-1.2,1.3h-4.1c-0.7,0-1.4-0.5-1.5-1.3L80.4,99 l-0.5-4.6l-1.4,5l-6.8,21.1c-0.2,0.7-0.9,1.2-1.6,1.2h-4C65.2,121.8,64.5,121.3,64.3,120.6z"
}), React.createElement("path", {
  id: "XMLID_91_",
  fill: "#FFFFFF",
  d: "M95.6,108.1V96.8c0-7.7,6.1-14,13.7-14c4.3,0,8.2,1.6,10.8,4.7c0.2,0.3,0.3,0.6,0.3,0.9 c0,0.4-0.2,0.7-0.4,1.1l-2.3,2.4c-0.3,0.3-0.5,0.4-0.8,0.4c-0.3,0-0.7-0.2-1-0.5c-1.6-1.8-3.9-2.8-6.5-2.8c-4,0-7.3,3.6-7.3,7.8 v11.3c0,4.2,3.3,7.8,7.3,7.8c2.7,0,4.9-1,6.5-2.8c0.3-0.3,0.6-0.5,0.9-0.5c0.3,0,0.6,0.2,0.9,0.4l2.3,2.4c0.3,0.3,0.5,0.7,0.5,1.1 c0,0.3-0.1,0.6-0.3,0.8c-2.6,3-6.5,4.7-10.9,4.7C101.8,122.1,95.6,115.9,95.6,108.1z"
}), React.createElement("path", {
  id: "XMLID_93_",
  fill: "#FFFFFF",
  d: "M127.3,107.1V84.7c0-0.6,0.5-1.1,1.1-1.1h4.2c0.6,0,1.1,0.5,1.1,1.1v22.7 c0,5.1,3.1,8.5,7.6,8.5c4.5,0,7.6-3.4,7.6-8.5V84.7c0-0.6,0.5-1.1,1.1-1.1h4.2c0.6,0,1.1,0.5,1.1,1.1v22.4c0,8.7-5.9,15-14,15 C133.3,122.1,127.3,115.8,127.3,107.1z"
})))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    "aria-hidden": "true",
    style: {
      "position": "absolute",
      "width": 0,
      "height": 0,
      "overflow": "hidden"
    },
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), React.createElement("defs", null, React.createElement("symbol", {
    id: "icon-python",
    viewBox: "0 0 32 32"
  }, _ref, React.createElement("path", {
    fill: "#3776ab",
    style: {
      "fill": "var(--color1, #3776ab)"
    },
    d: "M19.080 0.24l1.2 0.267 0.973 0.347 0.787 0.4 0.6 0.427 0.453 0.453 0.333 0.453 0.213 0.44 0.133 0.4 0.053 0.347 0.027 0.267-0.013 0.173v7.12l-0.067 0.84-0.173 0.733-0.28 0.613-0.347 0.507-0.4 0.413-0.44 0.333-0.467 0.253-0.467 0.187-0.44 0.133-0.4 0.093-0.347 0.053-0.28 0.027h-7.96l-0.92 0.067-0.787 0.187-0.667 0.293-0.547 0.36-0.44 0.427-0.36 0.467-0.267 0.48-0.2 0.493-0.133 0.467-0.093 0.427-0.053 0.36-0.027 0.28v4.080h-2.973l-0.28-0.040-0.373-0.093-0.427-0.16-0.467-0.24-0.48-0.347-0.48-0.48-0.467-0.613-0.427-0.787-0.373-0.973-0.28-1.173-0.187-1.4-0.067-1.64 0.080-1.627 0.213-1.387 0.32-1.16 0.427-0.947 0.48-0.76 0.533-0.587 0.56-0.44 0.56-0.32 0.533-0.213 0.48-0.133 0.427-0.067 0.32-0.013h0.213l0.080 0.013h10.88v-1.107h-7.787l-0.013-3.667-0.027-0.493 0.067-0.453 0.147-0.413 0.227-0.373 0.333-0.347 0.413-0.307 0.507-0.267 0.587-0.24 0.68-0.2 0.773-0.16 0.853-0.133 0.947-0.080 1.027-0.053 1.12-0.027 1.693 0.067 1.427 0.173zM10.68 2.88l-0.307 0.44-0.107 0.547 0.107 0.547 0.307 0.453 0.44 0.293 0.547 0.12 0.547-0.12 0.44-0.293 0.307-0.453 0.107-0.547-0.107-0.547-0.307-0.44-0.44-0.293-0.547-0.12-0.547 0.12-0.44 0.293z"
  }), React.createElement("path", {
    fill: "#3776ab",
    style: {
      "fill": "var(--color1, #3776ab)"
    },
    d: "M28.133 8.147l0.373 0.080 0.427 0.16 0.467 0.24 0.48 0.36 0.48 0.467 0.467 0.627 0.427 0.787 0.373 0.973 0.28 1.173 0.187 1.387 0.067 1.64-0.080 1.64-0.213 1.387-0.32 1.147-0.427 0.947-0.48 0.76-0.533 0.6-0.56 0.44-0.56 0.32-0.533 0.213-0.48 0.12-0.427 0.067-0.32 0.027-0.213-0.013h-10.96v1.093h7.787l0.013 3.68 0.027 0.48-0.067 0.453-0.147 0.413-0.227 0.387-0.333 0.333-0.413 0.32-0.507 0.267-0.587 0.227-0.68 0.2-0.773 0.173-0.853 0.12-0.947 0.093-1.027 0.053-1.12 0.013-1.693-0.053-1.427-0.187-1.2-0.267-0.973-0.333-0.787-0.4-0.6-0.44-0.453-0.453-0.333-0.453-0.213-0.44-0.133-0.4-0.053-0.333-0.027-0.267 0.013-0.173v-7.12l0.067-0.853 0.173-0.72 0.28-0.613 0.347-0.507 0.4-0.427 0.44-0.32 0.467-0.267 0.467-0.187 0.44-0.133 0.4-0.080 0.347-0.053 0.28-0.027 0.173-0.013h7.787l0.92-0.067 0.787-0.187 0.667-0.28 0.547-0.373 0.44-0.427 0.36-0.467 0.267-0.48 0.2-0.48 0.133-0.467 0.093-0.427 0.053-0.373 0.027-0.28v-4.080h2.787l0.187 0.013 0.28 0.040zM19.507 27.147l-0.307 0.44-0.107 0.547 0.107 0.547 0.307 0.44 0.44 0.307 0.547 0.107 0.547-0.107 0.44-0.307 0.307-0.44 0.107-0.547-0.107-0.547-0.307-0.44-0.44-0.307-0.547-0.107-0.547 0.107-0.44 0.307z"
  })), React.createElement("symbol", {
    id: "icon-raspberrypi",
    viewBox: "0 0 32 32"
  }, _ref2, React.createElement("path", {
    fill: "#c51a4a",
    style: {
      "fill": "var(--color2, #c51a4a)"
    },
    d: "M21.481 23.117c-1.143 1.319-1.779 3.72-0.945 4.495 0.795 0.599 2.935 0.521 4.513-1.64 1.147-1.44 0.759-3.857 0.108-4.496-0.973-0.74-2.371 0.219-3.676 1.657v-0.016zM10.739 23.517c-1.211-1.387-2.784-2.211-3.801-1.599-0.68 0.509-0.807 2.247 0.164 3.956 1.437 2.032 3.461 2.239 4.295 1.743 0.879-0.651 0.4-2.849-0.657-4.1zM16.212 27.711c-1.471-0.035-3.731 0.585-3.701 1.376-0.024 0.537 1.775 2.096 3.607 2.017 1.768 0.040 3.599-1.519 3.576-2.199-0.005-0.697-1.997-1.236-3.476-1.179l-0.005-0.016zM16.112 9.119c-1.7-0.043-3.336 1.244-3.336 1.991-0.005 0.907 1.344 1.835 3.347 1.859 2.057 0.013 3.357-0.745 3.376-1.68 0.021-1.059-1.859-2.185-3.357-2.169h-0.029zM12.017 9.828c-2.847-0.46-5.217 1.2-5.123 4.256 0.093 1.179 6.173-4.055 5.124-4.236l-0.001-0.020zM25.016 14.163c0.095-3.036-2.279-4.695-5.125-4.235-1.049 0.18 5.029 5.415 5.125 4.235zM25.501 15.261c-1.652-0.439-0.56 6.732 0.784 6.153 1.479-1.159 1.955-4.595-0.784-6.133v-0.020zM5.637 21.495c1.343 0.6 2.436-6.572 0.785-6.133-2.737 1.537-2.264 4.973-0.785 6.153v-0.020zM18.191 13.564c-1.528 1-1.805 3.237-0.615 4.995 1.188 1.757 3.391 2.417 4.921 1.437 1.528-0.977 1.804-3.216 0.616-4.995-1.189-1.777-3.393-2.417-4.923-1.417v-0.020zM14.063 13.744c-1.528-0.979-3.732-0.339-4.919 1.419-1.189 1.779-0.915 4.016 0.615 5.015s3.732 0.359 4.921-1.419c1.18-1.757 0.9-3.996-0.62-4.993l0.003-0.021zM19.888 23.293c-0.012-1.857-1.669-3.357-3.708-3.336-2.036 0.021-3.681 1.519-3.672 3.376v0.039c0.013 1.859 1.672 3.356 3.711 3.336 2.036 0 3.675-1.517 3.656-3.356v-0.039l0.013-0.020zM24.167 3.116c-3.076 1.579-4.869 2.837-5.852 3.917 0.503 1.997 3.125 2.077 4.084 2.016-0.196-0.080-0.361-0.199-0.42-0.359 0.24-0.16 1.095-0.021 1.691-0.34-0.228-0.040-0.336-0.081-0.439-0.26 0.559-0.18 1.167-0.32 1.521-0.62-0.191 0-0.371 0.040-0.623-0.12 0.503-0.259 1.037-0.479 1.46-0.877-0.261 0-0.541 0-0.621-0.1 0.461-0.28 0.847-0.58 1.169-0.939-0.363 0.060-0.52 0.021-0.605-0.040 0.348-0.34 0.791-0.639 0.999-1.080-0.271 0.101-0.521 0.12-0.696 0 0.121-0.259 0.627-0.419 0.92-1.039-0.287 0.040-0.588 0.061-0.648 0 0.131-0.519 0.359-0.817 0.58-1.139-0.609 0-1.533 0-1.489-0.039l0.377-0.38c-0.597-0.16-1.205 0.020-1.648 0.16-0.199-0.14 0-0.34 0.247-0.54-0.52 0.081-0.977 0.18-1.379 0.341-0.219-0.2 0.14-0.38 0.32-0.581-0.799 0.16-1.119 0.36-1.459 0.56-0.24-0.22-0.020-0.419 0.139-0.599-0.599 0.219-0.899 0.499-1.219 0.757-0.12-0.139-0.279-0.239-0.080-0.599-0.419 0.24-0.739 0.52-0.979 0.839-0.259-0.179-0.159-0.399-0.159-0.599-0.44 0.36-0.72 0.72-1.059 1.081-0.081-0.041-0.14-0.2-0.18-0.461-1.039 1-2.519 3.497-0.38 4.475 1.799-1.459 3.975-2.537 6.372-3.337l0.055-0.1zM7.821 3.116c2.397 0.8 4.559 1.877 6.369 3.357 2.128-1 0.657-3.497-0.376-4.475-0.055 0.259-0.113 0.439-0.18 0.479-0.34-0.36-0.616-0.72-1.051-1.080 0 0.2 0.103 0.44-0.156 0.6-0.233-0.319-0.547-0.6-0.967-0.84 0.199 0.341 0.033 0.44-0.075 0.599-0.32-0.3-0.62-0.579-1.199-0.799 0.16 0.199 0.4 0.4 0.16 0.62-0.319-0.199-0.659-0.4-1.437-0.56 0.18 0.199 0.539 0.4 0.317 0.6-0.42-0.163-0.88-0.283-1.38-0.344 0.241 0.2 0.456 0.385 0.256 0.54-0.46-0.16-1.075-0.34-1.673-0.18l0.379 0.379c0.040 0.049-0.879 0.040-1.495 0.047 0.22 0.3 0.449 0.599 0.58 1.139-0.060 0.060-0.36 0.021-0.644 0 0.3 0.599 0.799 0.76 0.917 1.020-0.18 0.128-0.419 0.1-0.697 0 0.219 0.419 0.659 0.719 0.997 1.080-0.099 0.059-0.24 0.099-0.619 0.049 0.319 0.347 0.699 0.659 1.159 0.939-0.080 0.093-0.361 0.092-0.639 0.1 0.419 0.405 0.959 0.619 1.459 0.884-0.26 0.181-0.44 0.14-0.62 0.14 0.34 0.3 0.96 0.439 1.519 0.619-0.12 0.18-0.219 0.22-0.459 0.26 0.599 0.339 1.437 0.18 1.677 0.36-0.060 0.159-0.219 0.279-0.419 0.36 0.959 0.060 3.596-0.020 4.096-2.019-0.981-1.076-2.779-2.336-5.855-3.895l0.053 0.021zM10.133 0.137c0.315-0.009 0.581 0.18 0.869 0.268 0.705-0.227 0.867 0.084 1.213 0.212 0.769-0.16 1.003 0.188 1.372 0.559l0.429-0.012c1.159 0.676 1.74 2.048 1.943 2.753 0.203-0.705 0.779-2.079 1.943-2.753l0.428 0.009c0.369-0.377 0.604-0.719 1.372-0.557 0.348-0.14 0.507-0.44 1.215-0.221 0.44-0.139 0.827-0.5 1.409-0.060 0.491-0.199 0.968-0.26 1.393 0.12 0.66-0.080 0.871 0.081 1.032 0.28 0.144 0 1.079-0.139 1.509 0.48 1.080-0.12 1.419 0.619 1.032 1.317 0.22 0.34 0.449 0.659-0.067 1.3 0.2 0.359 0.083 0.737-0.36 1.217 0.121 0.499-0.099 0.84-0.499 1.119 0.080 0.68-0.64 1.080-0.839 1.219-0.081 0.4-0.241 0.779-1.060 0.979-0.119 0.599-0.619 0.697-1.099 0.819 1.58 0.9 2.917 2.077 2.917 4.975l0.241 0.399c1.799 1.079 3.416 4.536 0.899 7.352-0.159 0.879-0.439 1.499-0.681 2.197-0.359 2.817-2.776 4.135-3.415 4.295-0.919 0.7-1.917 1.36-3.256 1.817-1.256 1.281-2.635 1.781-3.992 1.781h-0.123c-1.377 0-2.751-0.5-4.016-1.78-1.343-0.459-2.339-1.117-3.263-1.817-0.639-0.16-3.044-1.476-3.416-4.295-0.249-0.699-0.525-1.339-0.691-2.216-2.525-2.817-0.908-6.273 0.888-7.353l0.229-0.4c0-2.896 1.34-4.076 2.917-4.973-0.479-0.12-0.96-0.22-1.097-0.82-0.82-0.2-0.98-0.579-1.060-0.979-0.2-0.14-0.919-0.539-0.839-1.237-0.4-0.281-0.62-0.62-0.5-1.139-0.419-0.461-0.539-0.86-0.36-1.22-0.52-0.639-0.279-0.977-0.060-1.299-0.38-0.7-0.040-1.459 1.039-1.339 0.419-0.62 1.36-0.479 1.497-0.479 0.161-0.2 0.38-0.38 1.039-0.3 0.419-0.38 0.9-0.32 1.399-0.136 0.201-0.16 0.381-0.219 0.541-0.219l-0.076 0.137z"
  })), React.createElement("symbol", {
    id: "icon-dot-net",
    viewBox: "0 0 32 32"
  }, _ref3, React.createElement("path", {
    fill: "#5c2d91",
    style: {
      "fill": "var(--color3, #5c2d91)"
    },
    d: "M4.223 10.087v11.665h1.364v-8.433c0.003-0.094 0.004-0.204 0.004-0.314 0-0.453-0.025-0.9-0.074-1.339l0.005 0.054h0.051c0.108 0.28 0.233 0.52 0.38 0.744l-0.009-0.015 5.996 9.303h1.676v-11.665h-1.362v8.203c-0.002 0.079-0.003 0.172-0.003 0.265 0 0.511 0.031 1.014 0.091 1.509l-0.006-0.059h-0.031c-0.073-0.141-0.231-0.4-0.474-0.78l-5.836-9.138zM16.643 10.087v11.665h6.2l0.006-1.28h-4.812v-4.044h4.211v-1.229h-4.211v-3.878h4.518v-1.235zM23.893 10.087v1.235h3.353v10.431h1.362v-10.431h3.392v-1.235zM0.871 20.089c-0.241 0.006-0.456 0.11-0.608 0.274l-0.001 0.001c-0.162 0.162-0.263 0.386-0.263 0.634 0 0.002 0 0.004 0 0.006v-0c-0 0.003-0 0.008-0 0.012 0 0.246 0.1 0.468 0.262 0.628l0 0c0.158 0.166 0.38 0.269 0.626 0.269 0.005 0 0.010-0 0.014-0h-0.001c0.002 0 0.004 0 0.006 0 0.249 0 0.474-0.103 0.634-0.268l0-0c0.166-0.16 0.269-0.384 0.269-0.632 0-0.003 0-0.006-0-0.009v0c0-0.001 0-0.002 0-0.003 0-0.25-0.103-0.475-0.268-0.637l-0-0c-0.16-0.169-0.387-0.275-0.638-0.275-0.001 0-0.002 0-0.002 0h0c-0.005-0-0.010-0-0.016-0s-0.011 0-0.016 0h0.001z"
  })), React.createElement("symbol", {
    id: "icon-adobephotoshop",
    viewBox: "0 0 32 32"
  }, _ref4, React.createElement("path", {
    fill: "#00c8ff",
    style: {
      "fill": "var(--color4, #00c8ff)"
    },
    d: "M0 0.4v31.2h32v-31.2h-32zM1.333 1.733h29.333v28.533h-29.333v-28.533zM7.733 7.707c0-0.089 0.187-0.155 0.299-0.155 0.859-0.044 2.117-0.067 3.437-0.067 3.696 0 5.133 2.027 5.133 4.621 0 3.387-2.456 4.84-5.469 4.84-0.507 0-0.68-0.023-1.033-0.023v5.123c0 0.111-0.044 0.155-0.153 0.155h-2.059c-0.111 0-0.153-0.040-0.153-0.151v-14.344zM10.1 14.789c0.307 0.021 0.549 0.021 1.080 0.021 1.56 0 3.027-0.549 3.027-2.661 0-1.693-1.048-2.552-2.829-2.552-0.528 0-1.033 0.021-1.276 0.044v5.152zM21.576 13.205c-1.056 0-1.408 0.528-1.408 0.968 0 0.484 0.24 0.813 1.649 1.54 2.091 1.013 2.749 1.98 2.749 3.409 0 2.133-1.627 3.28-3.827 3.28-1.168 0-2.16-0.244-2.733-0.573-0.087-0.044-0.107-0.109-0.107-0.22v-1.956c0-0.133 0.064-0.177 0.152-0.112 0.832 0.551 1.803 0.792 2.683 0.792 1.056 0 1.496-0.44 1.496-1.035 0-0.484-0.307-0.903-1.649-1.607-1.893-0.907-2.685-1.827-2.685-3.369 0-1.716 1.341-3.147 3.673-3.147 1.147 0 1.952 0.176 2.392 0.373 0.109 0.067 0.133 0.176 0.133 0.264v1.827c0 0.111-0.067 0.177-0.2 0.133-0.592-0.352-1.467-0.573-2.324-0.573z"
  })), React.createElement("symbol", {
    id: "icon-html5",
    viewBox: "0 0 32 32"
  }, _ref5, React.createElement("path", {
    fill: "#e34f26",
    style: {
      "fill": "var(--color5, #e34f26)"
    },
    d: "M2 0h28l-2.547 28.751-11.484 3.249-11.419-3.251-2.551-28.749zM11.375 13l-0.309-3.624 13.412 0.004 0.307-3.496-17.568-0.004 0.931 10.68h12.168l-0.435 4.568-3.88 1.072-3.94-1.080-0.251-2.813h-3.479l0.44 5.561 7.229 1.933 7.172-1.924 0.992-10.876h-12.789z"
  })), React.createElement("symbol", {
    id: "icon-react",
    viewBox: "0 0 32 32"
  }, _ref6, React.createElement("path", {
    fill: "#61dafb",
    style: {
      "fill": "var(--color6, #61dafb)"
    },
    d: "M18.852 16c0 1.575-1.277 2.852-2.852 2.852s-2.852-1.277-2.852-2.852c0-1.575 1.277-2.852 2.852-2.852s2.852 1.277 2.852 2.852z"
  }), React.createElement("path", {
    fill: "#61dafb",
    style: {
      "fill": "var(--color6, #61dafb)"
    },
    d: "M8.011 21.673l-0.629-0.16c-4.691-1.185-7.381-3.197-7.381-5.519s2.691-4.333 7.381-5.519l0.629-0.159 0.177 0.624c0.545 1.86 1.163 3.443 1.899 4.957l-0.082-0.186 0.135 0.284-0.135 0.284c-0.656 1.329-1.275 2.912-1.761 4.551l-0.056 0.22-0.177 0.623zM7.089 11.933c-3.565 1.001-5.753 2.533-5.753 4.061 0 1.527 2.188 3.059 5.753 4.061 0.512-1.62 1.046-2.965 1.662-4.263l-0.086 0.202c-0.531-1.098-1.066-2.443-1.511-3.828l-0.065-0.234zM23.989 21.673l-0.177-0.625c-0.544-1.859-1.162-3.441-1.9-4.954l0.081 0.184-0.135-0.284 0.135-0.284c0.656-1.329 1.275-2.911 1.762-4.55l0.056-0.221 0.177-0.624 0.631 0.159c4.689 1.185 7.38 3.197 7.38 5.52s-2.691 4.333-7.38 5.519l-0.631 0.16zM23.335 15.995c0.64 1.385 1.169 2.747 1.576 4.061 3.567-1.003 5.753-2.535 5.753-4.061 0-1.528-2.188-3.059-5.753-4.061-0.511 1.619-1.045 2.963-1.662 4.262l0.086-0.2z"
  }), React.createElement("path", {
    fill: "#61dafb",
    style: {
      "fill": "var(--color6, #61dafb)"
    },
    d: "M7.080 11.927l-0.177-0.623c-1.319-4.648-0.919-7.979 1.097-9.141 1.977-1.141 5.152 0.207 8.479 3.621l0.453 0.465-0.453 0.465c-1.146 1.19-2.207 2.482-3.162 3.853l-0.068 0.103-0.18 0.257-0.313 0.027c-1.875 0.151-3.596 0.439-5.264 0.86l0.218-0.047-0.629 0.159zM9.608 3.087c-0.357 0-0.673 0.077-0.94 0.231-1.325 0.764-1.56 3.42-0.647 7.004 1.21-0.285 2.681-0.521 4.18-0.658l0.131-0.010c0.894-1.264 1.792-2.37 2.756-3.414l-0.020 0.022c-2.080-2.025-4.049-3.175-5.46-3.175zM22.393 30.236c-0.001 0-0.001 0 0 0-1.9 0-4.34-1.431-6.872-4.031l-0.453-0.465 0.453-0.465c1.146-1.19 2.206-2.482 3.16-3.854l0.068-0.103 0.18-0.257 0.312-0.027c1.875-0.15 3.597-0.438 5.267-0.858l-0.218 0.046 0.629-0.159 0.179 0.624c1.316 4.645 0.917 7.977-1.099 9.139-0.449 0.259-0.988 0.411-1.562 0.411-0.016 0-0.031-0-0.047-0l0.002 0zM16.932 25.728c2.080 2.025 4.049 3.175 5.46 3.175h0.001c0.356 0 0.673-0.077 0.939-0.231 1.325-0.764 1.561-3.421 0.647-7.005-1.212 0.286-2.682 0.522-4.182 0.658l-0.13 0.010c-0.893 1.265-1.791 2.371-2.755 3.416l0.020-0.022z"
  }), React.createElement("path", {
    fill: "#61dafb",
    style: {
      "fill": "var(--color6, #61dafb)"
    },
    d: "M24.92 11.927l-0.629-0.159c-1.453-0.376-3.175-0.664-4.939-0.806l-0.111-0.007-0.312-0.027-0.18-0.257c-1.021-1.474-2.082-2.766-3.237-3.966l0.009 0.010-0.453-0.465 0.453-0.465c3.325-3.413 6.499-4.761 8.479-3.621 2.016 1.163 2.416 4.493 1.099 9.14l-0.179 0.624zM19.667 9.653c1.523 0.139 2.969 0.364 4.312 0.668 0.915-3.584 0.679-6.24-0.647-7.004-1.317-0.761-3.793 0.405-6.4 2.944 0.943 1.022 1.841 2.128 2.666 3.289l0.069 0.103zM9.608 30.236c-0.014 0-0.030 0-0.046 0-0.574 0-1.113-0.152-1.577-0.419l0.015 0.008c-2.016-1.161-2.416-4.492-1.097-9.139l0.176-0.624 0.629 0.159c1.54 0.388 3.239 0.661 5.047 0.812l0.313 0.027 0.179 0.257c1.022 1.475 2.083 2.767 3.239 3.967l-0.010-0.010 0.453 0.465-0.453 0.465c-2.531 2.6-4.971 4.031-6.868 4.031zM8.021 21.667c-0.915 3.584-0.679 6.241 0.647 7.005 1.316 0.751 3.791-0.407 6.4-2.944-0.943-1.022-1.841-2.129-2.667-3.29l-0.069-0.103c-1.629-0.146-3.099-0.382-4.534-0.711l0.224 0.043z"
  }), React.createElement("path", {
    fill: "#61dafb",
    style: {
      "fill": "var(--color6, #61dafb)"
    },
    d: "M16 22.504c-1.097 0-2.225-0.048-3.355-0.141l-0.313-0.027-0.18-0.257c-0.544-0.768-1.139-1.691-1.697-2.639l-0.103-0.19c-0.452-0.758-0.971-1.732-1.45-2.728l-0.105-0.243-0.133-0.284 0.133-0.284c0.584-1.239 1.102-2.212 1.658-3.161l-0.103 0.191c0.552-0.955 1.159-1.907 1.8-2.829l0.18-0.257 0.313-0.027c1.005-0.090 2.174-0.142 3.355-0.142s2.35 0.052 3.505 0.153l-0.15-0.011 0.312 0.027 0.179 0.257c1.177 1.666 2.294 3.567 3.252 5.56l0.104 0.24 0.135 0.284-0.135 0.284c-1.058 2.232-2.176 4.133-3.439 5.925l0.083-0.125-0.179 0.257-0.312 0.027c-1.129 0.093-2.259 0.141-3.356 0.141zM13.071 21.059c1.973 0.148 3.885 0.148 5.86 0 1.004-1.445 1.978-3.104 2.827-4.836l0.101-0.228c-0.947-1.958-1.922-3.617-3.012-5.19l0.083 0.126c-0.877-0.071-1.898-0.111-2.929-0.111s-2.052 0.040-3.063 0.119l0.134-0.008c-1.008 1.447-1.983 3.106-2.83 4.84l-0.099 0.224c0.951 1.96 1.926 3.619 3.014 5.193l-0.085-0.13z"
  })), React.createElement("symbol", {
    id: "icon-javascript",
    viewBox: "0 0 32 32"
  }, _ref7, React.createElement("path", {
    fill: "#f7df1e",
    style: {
      "fill": "var(--color7, #f7df1e)"
    },
    d: "M0 0h32v32h-32v-32zM29.379 24.368c-0.233-1.46-1.184-2.687-4.004-3.831-0.981-0.46-2.072-0.78-2.396-1.52-0.121-0.44-0.14-0.68-0.061-0.94 0.2-0.861 1.22-1.12 2.020-0.88 0.52 0.16 1 0.56 1.301 1.2 1.379-0.901 1.379-0.901 2.34-1.5-0.36-0.56-0.539-0.801-0.781-1.040-0.84-0.94-1.959-1.42-3.779-1.379l-0.94 0.119c-0.901 0.22-1.76 0.7-2.28 1.34-1.52 1.721-1.081 4.721 0.759 5.961 1.82 1.36 4.481 1.659 4.821 2.94 0.32 1.56-1.16 2.060-2.621 1.88-1.081-0.24-1.68-0.781-2.34-1.781l-2.44 1.401c0.28 0.64 0.6 0.919 1.080 1.479 2.32 2.341 8.12 2.221 9.161-1.339 0.039-0.12 0.32-0.94 0.099-2.2l0.061 0.089zM17.401 14.708h-2.997c0 2.584-0.012 5.152-0.012 7.74 0 1.643 0.084 3.151-0.184 3.615-0.44 0.919-1.573 0.801-2.088 0.64-0.528-0.261-0.796-0.621-1.107-1.14-0.084-0.14-0.147-0.261-0.169-0.261l-2.433 1.5c0.407 0.84 1 1.563 1.765 2.023 1.14 0.68 2.672 0.9 4.276 0.54 1.044-0.301 1.944-0.921 2.415-1.881 0.68-1.24 0.536-2.76 0.529-4.461 0.016-2.739 0-5.479 0-8.239l0.005-0.075z"
  })), React.createElement("symbol", {
    id: "icon-css3",
    viewBox: "0 0 32 32"
  }, _ref8, React.createElement("path", {
    fill: "#1572b6",
    style: {
      "fill": "var(--color8, #1572b6)"
    },
    d: "M2 0h28l-2.547 28.751-11.484 3.249-11.42-3.251-2.549-28.749zM24.787 5.884l-17.573-0.004 0.284 3.496 13.5 0.003-0.34 3.621h-8.853l0.32 3.431h8.243l-0.488 4.697-3.88 1.072-3.941-1.080-0.251-2.813h-3.48l0.387 5.14 7.287 2.271 7.164-2.040 1.623-17.792z"
  })), React.createElement("symbol", {
    id: "icon-chrome",
    viewBox: "0 0 32 32"
  }, _ref9, React.createElement("path", {
    fill: "##dd310f",
    style: {
      "fill": "var(--color9, #07b21d)"
    },
    d: "M18.193 23.889l-4.581 7.934c-7.704-1.153-13.613-7.797-13.613-15.822 0-2.851 0.746-5.526 2.053-7.845l6.532 11.314c1.308 2.785 4.14 4.718 7.415 4.718 0.759 0 1.495-0.104 2.193-0.299z"
  }), React.createElement("path", {
    fill: "##dd310f",
    style: {
      "fill": "var(--color9, #dd310f)"
    },
    d: "M8.071 13.954l-4.579-7.931c2.932-3.671 7.445-6.023 12.508-6.023 5.857 0 10.978 3.148 13.767 7.844h-13.055c-0.235-0.020-0.472-0.031-0.711-0.031-3.809 0-7.018 2.614-7.929 6.142z"
  }), React.createElement("path", {
    fill: "#ffe500",
    style: {
      "fill": "var(--color9, #ffe500)"
    },
    d: "M21.728 10.156h9.171c0.711 1.81 1.101 3.781 1.101 5.844 0 8.776-7.066 15.9-15.818 15.998l6.544-11.334c0.921-1.324 1.462-2.932 1.462-4.664 0-2.287-0.943-4.357-2.459-5.844z"
  }), React.createElement("path", {
    fill: "#5666c4",
    style: {
      "fill": "var(--color9, #5666c4)"
    },
    d: "M10.188 16c0-3.205 2.607-5.813 5.813-5.813s5.813 2.607 5.813 5.813c0 3.205-2.608 5.813-5.813 5.813s-5.813-2.608-5.813-5.813z"
  })), _ref10, _ref11, _ref12, _ref13, React.createElement("symbol", {
    id: "icon-google-maps",
    viewBox: "0 0 512 512"
  }, React.createElement("circle", {
    style: {
      "fill": "#40A459"
    },
    cx: 255.722,
    cy: 256,
    r: 255.445
  }), React.createElement("path", {
    style: {
      "fill": "#378B4E"
    },
    d: "M255.722,0.555c-1.944,0-3.878,0.03-5.812,0.073c-0.492,0.011-0.983,0.022-1.474,0.037 c-1.843,0.051-3.682,0.119-5.514,0.209c-0.474,0.023-0.945,0.056-1.418,0.081c-1.394,0.077-2.785,0.165-4.174,0.264 c-0.699,0.05-1.397,0.098-2.094,0.153c-1.61,0.128-3.217,0.27-4.82,0.428c-0.829,0.082-1.654,0.173-2.479,0.262 c-0.991,0.108-1.98,0.221-2.968,0.34c-0.856,0.103-1.714,0.202-2.567,0.313c125.334,16.327,222.126,123.498,222.126,253.282 S347.737,492.953,222.403,509.28c0.854,0.111,1.71,0.211,2.567,0.313c0.987,0.119,1.977,0.232,2.968,0.34 c0.826,0.09,1.652,0.181,2.479,0.262c1.603,0.158,3.209,0.3,4.82,0.428c0.696,0.056,1.395,0.104,2.094,0.153 c1.388,0.099,2.779,0.188,4.174,0.264c0.473,0.027,0.945,0.058,1.418,0.081c1.833,0.09,3.672,0.158,5.514,0.209 c0.491,0.014,0.982,0.026,1.474,0.037c1.932,0.043,3.868,0.073,5.812,0.073c141.079,0,255.445-114.367,255.445-255.445 S396.801,0.555,255.722,0.555z"
  }), React.createElement("path", {
    style: {
      "fill": "#898790"
    },
    d: "M222.403,233.787l106.563-61.152c0,0,116.569,24.829,143.473-24.263l8.485-15.483l7.379,16.04 c15.321,33.304,23.42,70.329,23.42,107.071c0,84.691-41.95,163.833-112.217,211.703l-7.25,4.94L222.403,233.787z"
  }), React.createElement("path", {
    style: {
      "fill": "#7A797F"
    },
    d: "M511.166,256c0-44.143-11.198-85.671-30.908-121.898l-7.82,14.269 c-9.45,17.245-21.888,34.878-34.284,50.741c4.162,18.295,6.374,37.333,6.374,56.888c0,71.337-29.248,135.834-76.4,182.176 l23.852,34.666C463.639,427.598,511.166,347.012,511.166,256z"
  }), React.createElement("path", {
    style: {
      "fill": "#3D9AE3"
    },
    d: "M255.722,512c-87.455,0-168.01-44.081-215.484-117.917l-4.527-7.04l142.267-119.937l163.74,230.122 l-10.434,3.385C306.874,508.169,281.452,512,255.722,512z"
  }), React.createElement("path", {
    style: {
      "fill": "#1D81CE"
    },
    d: "M342.752,496.827l-17.317-24.795c-30.569,19.333-65.625,32.915-103.137,37.801 c10.906,1.42,22.13,1.612,33.424,1.612C286.17,511.445,315.674,506.6,342.752,496.827z"
  }), React.createElement("path", {
    style: {
      "fill": "#FFFFFF"
    },
    d: "M177.978,267.106l44.425-33.319l170.805,238.278l-8.302,4.872 c-11.729,6.884-24.073,12.861-36.69,17.766l-6.499,2.527L177.978,267.106z"
  }), React.createElement("path", {
    style: {
      "fill": "#E0E0E3"
    },
    d: "M341.718,497.229c18.2-6.475,35.457-14.944,51.49-25.164l-24.615-34.338 c-13.395,13.232-28.248,24.992-44.293,35.023L341.718,497.229z"
  }), React.createElement("path", {
    style: {
      "fill": "#FFCE00"
    },
    d: "M31.37,379.188c-7.01-12.718-12.964-26.113-17.696-39.813l-2.112-8.059l299.691-208.592 l44.425,33.319L35.712,387.042L31.37,379.188z"
  }), React.createElement("path", {
    style: {
      "fill": "#CD2900"
    },
    d: "M382.579,250.216c-15.713-16.41-94.094-100.753-94.094-149.704C288.485,45.089,333.575,0,388.997,0 s100.512,45.089,100.512,100.512c0,48.918-78.382,133.287-94.095,149.704l0,0C391.917,253.87,386.077,253.871,382.579,250.216 L382.579,250.216z"
  }), React.createElement("path", {
    style: {
      "fill": "#891D00"
    },
    d: "M388.997,134.386c-24.803,0-44.98-20.178-44.98-44.98s20.178-44.98,44.98-44.98 c24.803,0,44.98,20.178,44.98,44.98S413.8,134.386,388.997,134.386z"
  }), React.createElement("path", {
    style: {
      "fill": "#FFFFFF"
    },
    d: "M144.659,186.586c29.088,0,52.755-23.666,52.755-52.755c0-4.6-3.729-8.33-8.33-8.33h-33.319 c-4.6,0-8.33,3.729-8.33,8.33c0,4.6,3.729,8.33,8.33,8.33h24.018c-3.769,15.901-18.088,27.766-35.125,27.766 c-19.902,0-36.095-16.193-36.095-36.095s16.193-36.095,36.095-36.095c8.8,0,17.275,3.202,23.865,9.015 c3.452,3.044,8.715,2.713,11.757-0.736c3.043-3.45,2.713-8.714-0.736-11.757c-9.636-8.5-22.025-13.181-34.886-13.181 c-29.088,0-52.755,23.666-52.755,52.755S115.57,186.586,144.659,186.586z"
  })), _ref14, _ref15, _ref16));
};

export default __webpack_public_path__ + "static/media/symbol-defs.e8acf989.svg";
export { SvgComponent as ReactComponent };